import React from 'react';

// German translations (Deutsch)
export const germanTranslations = {
  // ========== NAVIGATION & LAYOUT ==========
  title: "Duelity Gaming Tournament Platform",
  welcome: "Willkommen",
  points: "Punkte",
  logout: "Abmelden",
  tournaments: "Turniere",
  pointsProfile: "Punkte & Profil",
  matchHistory: "Spielverlauf",
  adminPanel: "Admin-Panel",
  approverPanel: "Genehmiger-Panel",
  supervisorPanel: "Supervisor-Panel",
  managerPanel: "Manager-Panel",
  login: "Anmelden",
  register: "Hier registrieren",
  myProfile: "Mein Profil",
  dontHaveAccount: "Kein Konto?",
  language: "Sprache",
  liveChat: "Live-Chat",
  menu: "Menü",
  publicProfile: "ÖFFENTLICH",
  levelsBadges: "Level & Fortschritt",

  // ========== AUTHENTIFIZIERUNG ==========
  username: "Benutzername",
  password: "Passwort",
  email: "E-Mail",
  inGameName: "Spielername",
  backToLogin: "Zurück zur Anmeldung",
  createAccount: "Konto erstellen",
  loginSuccessful: "Anmeldung erfolgreich!",
  welcomeBattlefield: "Willkommen auf dem Schlachtfeld!",
  registrationSuccessful: "Registrierung erfolgreich!",
  logoutSuccessful: "Erfolgreich abgemeldet",
  loggingIn: "Anmeldung läuft...",
  creatingAccount: "Konto wird erstellt...",

  // ========== FELDVALIDIERUNG ==========
  loginSubtitle: "Melden Sie sich bei Ihrem Konto an",
  fillAllFields: "Füllen Sie alle Felder aus, um Ihr Konto zu erstellen",
  enterUsername: "Benutzername eingeben",
  enterPassword: "Passwort eingeben",
  enterEmail: "E-Mail-Adresse eingeben",
  enterInGameName: "Enter your in-game name",
  reenterPassword: "Passwort erneut eingeben",
  confirmPassword: "Passwort bestätigen",

  // Validierungsfehler
  usernameRequired: "Benutzername ist erforderlich",
  usernameTooShort: "Benutzername muss mindestens 3 Zeichen haben",
  usernameTooLong: "Benutzername darf nicht mehr als 20 Zeichen haben",
  usernameNoHebrew: "Benutzername darf keine hebräischen Zeichen enthalten",
  usernameNoArabic: "Benutzername darf keine arabischen Zeichen enthalten",
  usernameInvalidChars: "Benutzername darf nur Buchstaben, Zahlen, Unterstrich und Bindestrich enthalten",
  emailRequired: "E-Mail ist erforderlich",
  emailInvalid: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
  inGameNameRequired: "Spielername ist erforderlich",
  inGameNameTooShort: "Spielername muss mindestens 2 Zeichen haben",
  inGameNameTooLong: "Spielername darf nicht mehr als 30 Zeichen haben",
  passwordRequired: "Passwort ist erforderlich",
  passwordTooShort: "Passwort muss mindestens 6 Zeichen haben",
  passwordTooLong: "Passwort darf nicht mehr als 50 Zeichen haben",
  passwordNeedsNumber: "Passwort muss mindestens eine Zahl enthalten",
  passwordNeedsLetter: "Passwort muss mindestens einen Buchstaben enthalten",
  confirmPasswordRequired: "Bitte bestätigen Sie Ihr Passwort",
  passwordsDoNotMatch: "Passwörter stimmen nicht überein",

  // Validierungserfolg
  usernameValid: "Benutzername ist gültig",
  emailValid: "E-Mail ist gültig",
  inGameNameValid: "Spielername ist gültig",
  passwordValid: "Passwort ist gültig",
  passwordsMatch: "Passwörter stimmen überein",

  // Passwortanforderungen
  min6Chars: "Mindestens 6 Zeichen",
  hasLetter: "Enthält einen Buchstaben",
  hasNumber: "Enthält eine Zahl",

  // Anmeldefehler
  invalidCredentials: "Ungültiger Benutzername oder Passwort",
  userNotFound: "Benutzer nicht gefunden. Überprüfen Sie Ihren Benutzernamen.",
  wrongPassword: "Falsches Passwort. Bitte versuchen Sie es erneut.",
  accountDisabled: "Ihr Konto wurde deaktiviert. Kontaktieren Sie den Support.",
  loginFailed: "Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.",
  registrationFailed: "Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.",

// ========== PASSWORT WIEDERHERSTELLUNG ==========  forgotPassword: "Passwort vergessen?",  forgotPasswordTitle: "Passwort vergessen",  forgotPasswordSubtitle: "Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen.",  sendResetLink: "Link senden",  sending: "Wird gesendet...",  checkYourEmail: "Überprüfen Sie Ihre E-Mail",  resetLinkSent: "Wenn ein Konto mit dieser E-Mail existiert, erhalten Sie in Kürze einen Link. Bitte überprüfen Sie auch Ihren Spam-Ordner.",  linkExpiresIn: "Der Link läuft in 1 Stunde ab.",  resetPassword: "Zurücksetzen",  resetPasswordTitle: "Passwort zurücksetzen",  resetPasswordSubtitle: "Geben Sie unten Ihr neues Passwort ein.",  newPassword: "Neues Passwort",  confirmNewPassword: "Passwort bestätigen",  enterNewPassword: "Neues Passwort eingeben",  confirmNewPasswordPlaceholder: "Neues Passwort bestätigen",  resetting: "Wird zurückgesetzt...",  passwordResetSuccess: "Passwort zurückgesetzt!",  passwordResetSuccessMessage: "Ihr Passwort wurde erfolgreich zurückgesetzt.",  redirectingToLogin: "Weiterleitung zur Anmeldeseite...",  loginNow: "Jetzt anmelden",  invalidResetLink: "Ungültiger Link",  invalidResetLinkMessage: "Dieser Link ist ungültig oder abgelaufen.",  resetLinkExpiredNote: "Links laufen nach 1 Stunde aus Sicherheitsgründen ab.",  requestNewResetLink: "Neuen Link anfordern",  verifyingResetLink: "Link wird überprüft...",
  
  // ========== PASSWORD RECOVERY ==========
  forgotPassword: "Passwort vergessen?",
  forgotPasswordTitle: "Passwort vergessen",
  forgotPasswordSubtitle: "Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen.",
  sendResetLink: "Link senden",
  sending: "Wird gesendet...",
  checkYourEmail: "Überprüfen Sie Ihre E-Mail",
  resetLinkSent: "Wenn ein Konto mit dieser E-Mail existiert, erhalten Sie in Kürze einen Link. Bitte überprüfen Sie auch Ihren Spam-Ordner.",
  linkExpiresIn: "Der Link läuft in 1 Stunde ab.",
  resetPassword: "Zurücksetzen",
  resetPasswordTitle: "Passwort zurücksetzen",
  resetPasswordSubtitle: "Geben Sie unten Ihr neues Passwort ein.",
  newPassword: "Neues Passwort",
  confirmNewPassword: "Passwort bestätigen",
  enterNewPassword: "Neues Passwort eingeben",
  confirmNewPasswordPlaceholder: "Neues Passwort bestätigen",
  resetting: "Wird zurückgesetzt...",
  passwordResetSuccess: "Passwort zurückgesetzt!",
  passwordResetSuccessMessage: "Ihr Passwort wurde erfolgreich zurückgesetzt.",
  redirectingToLogin: "Weiterleitung zur Anmeldeseite...",
  loginNow: "Jetzt anmelden",
  invalidResetLink: "Ungültiger Link",
  invalidResetLinkMessage: "Dieser Link ist ungültig oder abgelaufen.",
  resetLinkExpiredNote: "Links laufen nach 1 Stunde aus Sicherheitsgründen ab.",
  requestNewResetLink: "Neuen Link anfordern",
  verifyingResetLink: "Link wird überprüft...",

// ========== LEVEL-SYSTEM KERN ==========
  level: "Level",
  levels: "Level",
  experience: "Erfahrung",
  exp: "EXP",
  totalExp: "Gesamt-EXP",
  expNeeded: "EXP benötigt",
  expToNext: "EXP bis zum nächsten Level",
  expGained: "EXP erhalten",
  expReward: "EXP-Belohnung",
  currentLevel: "Aktuelles Level",
  nextLevel: "Nächstes Level",
  maxLevel: "MAX LEVEL!",
  levelUp: "LEVEL UP!",
  levelProgress: "Level-Fortschritt",
  levelSystem: "Level-System",
  loadingLevel: "Level wird geladen...",
  levelTooltip: "Level {level} - {title}\n{totalExp} Gesamt-EXP\n{remaining}",

  // ========== LEVEL-TITEL ==========
  beginner: "Anfänger",
  novice: "Neuling",
  intermediate: "Fortgeschrittener",
  advanced: "Erfahrener",
  professional: "Profi",
  expert: "Experte",
  master: "Meister",
  grandmaster: "Großmeister",
  mythic: "Mythisch",
  sage: "Weiser",
  legend: "Legende",

  // ========== ABZEICHEN-SYSTEM ==========
  badges: "Abzeichen",
  badge: "Abzeichen",
  earnedBadges: "Erhalten",
  inProgress: "In Bearbeitung",
  allBadges: "Alle",
  loadingBadges: "Abzeichen werden geladen...",
  noBadges: "Noch keine Abzeichen",
  badgeUnlocked: "Abzeichen freigeschaltet!",
  badgeProgress: "Abzeichen-Fortschritt",
  badgeModal: "Abzeichen-Details",
  comingSoon: "Demnächst verfügbar",
  systemLoading: "System wird geladen...",
  noBadgesYet: "Noch keine Abzeichen",
  characterCount: "{count}/1000",
  progressPercentage: "{percentage}% abgeschlossen",
  currentProgress: "Aktueller Fortschritt",

  // ========== ABZEICHEN-KATEGORIEN ==========
  allCategories: "Alle Kategorien",
  winStreak: "Siegesserie",
  filler: "Füller",
  totalWins: "Gesamtsiege",
  pointsWinning: "Gewonnene Punkte",
  pointsPurchase: "Punkte-Kauf",
  multiplayer: "Mehrspieler",
  battleRoyale: "Battle Royale",
  multiplayerWins: "Mehrspieler-Siege",
  battleRoyaleWins: "Battle Royale-Siege",

  // ========== ABZEICHEN-SELTENHEIT ==========
  common: "Gewöhnlich",
  rare: "Selten",
  epic: "Episch",
  legendary: "Legendär",

  // ========== ABZEICHEN-MODAL ==========
  close: "Schließen",
  category: "Kategorie",
  requirement: "Voraussetzung",
  unlocked: "Freigeschaltet",
  unlockedOn: "Freigeschaltet am",
  progress: "Fortschritt",
  remaining: "übrig",
  tip: "Tipp",
  gotIt: "Verstanden!",

  // ========== FORTSCHRITTSANZEIGEN ==========
  complete: "Abgeschlossen",
  completion: "Abschluss",
  showMore: "Mehr anzeigen",
  showLess: "Weniger anzeigen",
  upcoming: "Kommend",
  upcomingMilestones: "Kommende Meilensteine",
  congratsMaxLevel: "Herzlichen Glückwunsch! Du hast das maximale Level erreicht!",
  totalExpEarned: "Gesamt-EXP verdient",
  progressDetails: "Fortschrittsdetails",
  expForCurrentLevel: "EXP für aktuelles Level",
  expForNextLevel: "EXP für nächstes Level",
  progressToNext: "Fortschritt zum nächsten Level",

  // ========== STATUSANZEIGEN ==========
  loading: "Lädt...",
  loadingProgress: "Fortschritt wird geladen...",
  offline: "Offline",
  online: "Online",

  // ========== ABZEICHEN-TIPPS ==========
  winStreakTip: "Gewinne weiterhin aufeinanderfolgende Spiele, um diesen Meilenstein zu erreichen! Du brauchst {remaining} weitere Siege in Folge.",
  totalWinsTip: "Gewinne mehr Turniere, um dieses Abzeichen freizuschalten. {remaining} Siege noch!",
  pointsWinningTip: "Verdiene mehr Punkte durch Turniersiege. Du brauchst {remaining} weitere Punkte.",
  pointsPurchaseTip: "Kaufe mehr Punkte, um dieses Abzeichen freizuschalten. {remaining} Punkte noch zu kaufen.",
  fillerTip: "Füge Füller-Spieler zu Turnieren hinzu und hoffe, dass sie gewinnen! {remaining} weitere Füller-Siege benötigt.",
  multiplayerTip: "Spiele mehr Mehrspieler-Turniere. {remaining} Spiele übrig.",
  battleRoyaleTip: "Nimm an mehr Battle Royale-Matches teil. {remaining} Spiele übrig.",
  multiplayerWinsTip: "Gewinne mehr Mehrspieler-Turniere. {remaining} Siege benötigt.",
  battleRoyaleWinsTip: "Gewinne mehr Battle Royale-Matches. {remaining} Siege zum Freischalten.",
  genericTip: "Spiele weiter, um dieses Abzeichen freizuschalten! {remaining} noch übrig.",

  // ========== LEVEL-UP-BENACHRICHTIGUNGEN ==========
  levelUpNotification: "Level Up!",
  levelUpTitle: "Herzlichen Glückwunsch!",
  levelUpSubtitle: "Du hast ein neues Level erreicht!",
  newLevelUnlocked: "Neues Level freigeschaltet",
  titleEarned: "Titel erhalten",

  // ========== STATISTIKEN ==========
  statistics: "Statistiken",
  totalEarned: "Gesamt verdient",
  totalAvailable: "Gesamt verfügbar",
  completionPercentage: "Abschlussprozent",
  earnedCount: "Anzahl erhalten",
  progressCount: "In Bearbeitung",

  // ========== ERFOLGS-NACHRICHTEN ==========
  achievementUnlocked: "Erfolg freigeschaltet!",
  newBadgeEarned: "Neues Abzeichen erhalten!",
  levelMilestone: "Level-Meilenstein!",
  experienceGained: "Erfahrung erhalten: +{amount}",

  // ========== FEHLERMELDUNGEN ==========
  failedToLoadBadges: "Fehler beim Laden der Abzeichen",
  failedToLoadLevel: "Fehler beim Laden des Levels",
  failedToLoadProgress: "Fehler beim Laden des Fortschritts",

  // ========== AKTIONS-BUTTONS ==========
  viewDetails: "Details anzeigen",
  trackProgress: "Fortschritt verfolgen",
  shareAchievement: "Erfolg teilen",

  // ========== BENACHRICHTIGUNGEN ==========
  badgeEarned: "Abzeichen erhalten: {badgeName}",
  levelIncreased: "Level Up! Jetzt Level {level}",
  milestoneReached: "Meilenstein erreicht!",

  // ========== KOMPAKT-ANZEIGEN ==========
  lvl: "Lv",
  expShort: "EXP",
  badgesShort: "Abzeichen",

  // ========== FORTSCHRITTSBALKEN ==========
  progressBarLabel: "Fortschritt: {current}/{total}",
  completionRate: "Abschlussrate: {percentage}%",

  // ========== ZEIT ==========
  recentlyUnlocked: "Kürzlich freigeschaltet",
  timeToUnlock: "Zeit zum Freischalten",
  earnedToday: "Heute verdient",
  earnedThisWeek: "Diese Woche verdient",

  // ========== FILTER UND SORTIERUNG ==========
  filterByCategory: "Nach Kategorie filtern",
  sortByProgress: "Nach Fortschritt sortieren",
  sortByRarity: "Nach Seltenheit sortieren",
  sortByDate: "Nach Datum sortieren",

  // ========== HILFETEXT ==========
  howToEarnBadges: "Wie man Abzeichen erhält",
  levelSystemExplanation: "Level-System-Erklärung",
  experienceExplanation: "Erfahrungspunkte-Erklärung",

  // ========== SPEZIELLE EVENTS ==========
  specialEvent: "Spezielles Event",
  limitedTime: "Zeitlich begrenzt",
  eventBadge: "Event-Abzeichen",
  seasonalBadge: "Saisonales Abzeichen",

  // ========== ÖFFENTLICHES PROFIL ==========
  profileTitle: "{name}s Profil",
  playerNotFound: "Spieler nicht gefunden",
  profilePrivate: "Dieses Profil ist privat",
  failedToLoadProfile: "Fehler beim Laden des Profils",
  playerNotFoundDesc: "Der gesuchte Spieler existiert nicht oder wurde gesperrt.",
  profilePrivateDesc: "Dieser Spieler hat sein Profil privat gemacht.",
  profileLoadError: "Beim Laden des Profils ist ein Fehler aufgetreten. Bitte versuche es erneut.",
  yourProfile: "Dein Profil",
  searchOtherPlayer: "Nach anderem Spieler suchen",
  findPlayer: "Spieler finden",
  searchPlayerDesc: "Suche nach einem Spieler per Benutzername oder Spielername, um sein öffentliches Profil zu sehen.",
  loadingProfile: "Profil wird geladen...",
  loadingPlayerProfile: "Spielerprofil wird geladen...",
  playerProfiles: "Spielerprofile",

  // ========== RANGLISTE ==========
  wins: "Siege",
  avgPrize: "Durchschnitt",
  totalPrize: "Gesamtpreis",
  losses: "Niederlagen",
  leaderboard: "Rangliste",
  levelLeaderboard: "Level-Rangliste",
  winsLeaderboard: "Siege-Rangliste",
  winStreakLeaderboard: "Siegesserie-Rangliste",
  pointsLeaderboard: "Punkte-Rangliste",
  levelLeaderboardDesc: "Top-Spieler nach Erfahrungspunkten und Level",
  winsLeaderboardDesc: "Top-Spieler nach Gesamtturnier-Siegen",
  winStreakLeaderboardDesc: "Top-Spieler mit aktuellen Siegesserien",
  pointsLeaderboardDesc: "Top-Spieler nach aktuellem Punktestand",
  loadingLeaderboard: "Rangliste wird geladen...",
  loadingRankings: "Spieler-Rankings werden geladen...",
  failedToLoadLeaderboard: "Fehler beim Laden der Rangliste",
  leaderboardRefreshed: "Rangliste aktualisiert!",
  leaderboardLoadError: "Beim Laden der Rangliste ist ein Fehler aufgetreten. Bitte versuche es erneut.",
  noDataAvailable: "Keine Daten verfügbar",
  noActiveStreaks: "Aktuell hat kein Spieler aktive Siegesserien.",
  noPlayersFound: "Keine Spieler für diese Rangliste gefunden.",
  fullRankings: "Vollständige Rankings",
  champion: "Champion",
  currentStreak: "Aktuelle Serie",
  maxStreak: "Max",
  levelDesc: "Nach Erfahrung",
  winsDesc: "Nach Siegen",
  winStreakDesc: "Aktuelle Serien",
  pointsDesc: "Nach Guthaben",
  lastUpdated: "Zuletzt aktualisiert",
  accountAge: "Kontoalter",
  days: "Tage",
  you: "(Du)",
  searchFromLeaderboard: "Spieler suchen...",

  // ========== ERWEITERTE PROFIL-KOMPONENTEN ==========
  profile: "Profil",
  overview: "Übersicht",
  mainAdmin: "Haupt-Admin",
  supervisor: "Supervisor",
  approver: "Genehmiger",
  manager: "Manager",
  verifiedSponsor: "Verifizierter Sponsor",
  player: "Spieler",
  memberSince: "Mitglied seit",
  lastSeen: "Zuletzt gesehen",
  currentlyOnline: "Derzeit:",
  fillerWins: "Füller-Siege",
  bestWinStreak: "Beste Siegesserie",
  gameModeStats: "Spielmodus-Statistiken",
  accountInformation: "Kontoinformationen",
  funStats: "Spaß-Statistiken",
  played: "Gespielt",
  multiplayerWinRate: "Mehrspieler-Siegquote",
  battleRoyaleWinRate: "Battle Royale-Siegquote",

  // ========== SUCHE UND ALLGEMEINES ==========
  search: "Suchen",
  searchForPlayer: "Spieler suchen",
  searchPlayerPlaceholder: "Nach Benutzername oder Spielername suchen...",
  searching: "Suche läuft...",
  playersFound: "Spieler gefunden",
  noPlayersFoundQuery: "Keine Spieler gefunden, die \"{query}\" entsprechen",
  searchTipExact: "Versuche, mit dem genauen Benutzernamen oder Spielernamen zu suchen",
  searchTipUsername: "Nach Benutzername suchen (z.B. @player123)",
  searchTipInGame: "Nach Spielername suchen (z.B. ProGamer)",
  searchTip: "↑↓ zum Navigieren, Enter zum Auswählen, Esc zum Schließen",

  // ========== ABZEICHEN UND PROFIL ==========
  badgeCollection: "Abzeichen-Sammlung",
  earned: "Erhalten",
  categoryBreakdown: "Kategorieaufschlüsselung",
  achievementSummary: "Erfolgsübersicht",
  badgeSystemNotAvailable: "Das Abzeichen-System ist für dieses Profil nicht verfügbar.",
  badgesPrivateDesc: "Dieser Spieler hat seine Abzeichen-Sammlung privat gemacht.",
  badgesLoadError: "Beim Laden der Abzeichen-Sammlung ist ein Fehler aufgetreten.",
  badgeSummaryText: "hat {earned} von {total} verfügbaren Abzeichen erhalten ({percentage}% Abschluss). Er hat {categories} verschiedene Kategorien freigeschaltet und insgesamt {exp} Erfahrungspunkte aus Abzeichen erhalten.",
  recentlyEarned: "Kürzlich erhalten",
  showProgress: "Fortschritt anzeigen",
  categoriesUnlocked: "Kategorien",
  totalExpFromBadges: "Gesamt-EXP aus Abzeichen",

  // ========== SPIELVERLAUF ==========
  noMatches: "Keine Spiele gefunden",
  noMatchesDesc: "Dieser Spieler hat noch keine öffentlichen Spiele abgeschlossen.",
  loadingMatches: "Spiele werden geladen...",
  total: "Gesamt",
  prizeWon: "Gewonnener Preis",
  winRate: "Siegquote",
  map: "Karte",
  maxKills: "Max Kills",
  entry: "Eintritt",
  prize: "Preis",
  players: "Spieler",
  by: "von",
  won: "GEWONNEN",
  lost: "VERLOREN",
  shared: "Geteilt",
  thisPlayer: "Dieser Spieler",
  matchSummary: "Spielzusammenfassung",
  winLossRecord: "Sieg/Niederlage-Bilanz",
  totalPrizeWon: "Gesamtpreis gewonnen",
  averagePrize: "Durchschnittspreis pro Sieg",

  // ========== DETAILLIERTE STATISTIKEN ==========
  detailedStatistics: "Detaillierte Statistiken",
  quickStats: "Schnellstatistiken",
  overallPerformance: "Gesamtleistung",
  gameModeBreakdown: "Spielmodus-Aufschlüsselung",
  pointsStatistics: "Punkte-Statistiken",
  specialAchievements: "Besondere Erfolge",
  playerSummary: "Spieler-Zusammenfassung",
  playerSummaryText: "ist ein {performance}-Spieler mit {wins} Siegen aus {total} Spielen und einer Siegquote von {winRate}%. Er ist derzeit global auf Rang #{rank}.",
  currentStreakText: "Er ist derzeit auf einer {streak}-Siegesserie!",
  bestStreakText: "Seine beste Siegesserie war {streak} aufeinanderfolgende Siege.",
  elite: "Elite",
  pro: "Profi",
  average: "Durchschnitt",
  fillerMaster: "Füller-Meister",
  fillerWinsDesc: "Gewann Turniere mit KI-Füllern",
  streakWarrior: "Serien-Krieger",
  streakDesc: "Erreichte beeindruckende Siegesserien",
  globalRank: "Globaler Rang",
  byExperience: "Nach Erfahrung",
  currentPoints: "Aktuelle Punkte",
  pointsWon: "Gewonnene Punkte",
  pointsLost: "Verlorene Punkte",
  netGain: "Nettogewinn",
  avgPerWin: "Durchschn. pro Sieg",
  fromLosses: "Aus Niederlagen",
  pointsPurchased: "Gekaufte Punkte",
  teamBased: "Team-basierte Spiele",
  survivalMode: "Überlebensmodus",
  matchesPlayed: "Gespielte Matches",
  totalMatches: "Gesamt-Matches",
  badgesEarned: "Erhaltene Abzeichen",
  badgeExp: "Abzeichen-EXP",
  categories: "Kategorien",

  // ========== ROLLEN ==========
  roleChanged: "Deine Rolle wurde geändert",
  commissionEarned: "Verdiente Provision",
  matchesApproved: "Genehmigte Matches",
  approversManaged: "Verwaltete Genehmiger",
  roleUpdated: "Rolle aktualisiert",
  roleChangedTo: "Deine Rolle wurde geändert zu",
  changedBy: "Geändert von",
  reason: "Grund",
  commissionRates: "Provisionssätze",

  // ========== TURNIER-BEREINIGUNG ==========
  oldTournamentRemoved: 'Altes Turnier automatisch entfernt',
  tournamentsAutoRemoved: '{count} alte(s) Turnier(e) aus der Lobby entfernt',
  pointsRefunded: '{amount} Punkte an Spieler erstattet',
  adminCleanupActivity: 'Bereinigung: {deleted} Turniere entfernt, {refunded} Punkte erstattet',
  manualCleanupTriggered: 'Manuelle Bereinigung durch {admin}: {deleted} Turniere gelöscht',
  autoCleanup: 'Auto-Bereinigung',
  removes: 'Entfernt',
  old: 'alte',
  cleanupNow: 'Jetzt bereinigen',
  active: 'Aktiv',
  stopped: 'Gestoppt',
  onlyMainAdminCanCleanup: 'Nur Haupt-Admins können manuelle Bereinigung auslösen',
  manualCleanupCompleted: 'Manuelle Bereinigung abgeschlossen: {deleted} Turniere entfernt',
  manualCleanupFailed: 'Manuelle Bereinigung fehlgeschlagen',
  tournamentAutoDeleted: 'Turnier wegen Alter automatisch gelöscht',
  tournamentDeletedOld: 'Altes Turnier aus Lobby entfernt',
  cleanupServiceActive: 'Bereinigungsdienst ist aktiv',
  cleanupServiceStopped: 'Bereinigungsdienst ist gestoppt',
  tournamentCleanupStatus: 'Turnier-Bereinigungsstatus',
  maxAgeInLobby: 'Max. Alter in Lobby',
  cleanupInterval: 'Bereinigungsintervall',
  lastCleanup: 'Letzte Bereinigung',
  nextCleanup: 'Nächste Bereinigung',
  tournamentsProcessed: 'Verarbeitete Turniere',
  totalRefundedAmount: 'Gesamt erstattet',
  cleanupConfiguration: 'Bereinigungskonfiguration',
  enableAutoCleanup: 'Automatische Bereinigung aktivieren',
  maxAgeHours: 'Maximales Alter (Stunden)',
  intervalMinutes: 'Bereinigungsintervall (Minuten)',
  maxPerRun: 'Max. Turniere pro Durchlauf',
  enableNotifications: 'Benachrichtigungen aktivieren',
  saveConfiguration: 'Konfiguration speichern',
  configurationSaved: 'Konfiguration erfolgreich gespeichert',
  configurationFailed: 'Fehler beim Speichern der Konfiguration',
  triggerManualCleanup: 'Manuelle Bereinigung auslösen',
  cleanupInProgress: 'Bereinigung läuft...',
  cleanupCompleted: 'Bereinigung abgeschlossen',
  noOldTournaments: 'Keine alten Turniere gefunden',
  cleanupSummary: 'Bereinigungszusammenfassung',
  deletedCount: 'Gelöscht',
  refundedAmount: 'Erstattet',
  errors: 'Fehler',
  duration: 'Dauer',
  tournamentAgeWarning: 'Turnier wird in {time} automatisch gelöscht',
  tournamentAgeInfo: 'Turnieralter: {age}',
  autoDeleteIn: 'Auto-Löschung in',
  minutes: 'Minuten',
  hours: 'Stunden',

  // ========== FÜLLER-VERWALTUNG ==========
  addFiller: "Füller hinzufügen",
  fillerManagement: "FÜLLER-VERWALTUNG",
  fillerPlayers: "Füller-Spieler",
  fillerName: "Füller-Spielername",
  enterFillerName: "Füller-Namen eingeben...",
  fillerNameRequired: "Füller-Name ist erforderlich",
  fillerNameTooLong: "Füller-Name zu lang (max 20 Zeichen)",
  fillerNameHelp: "Wähle einen eindeutigen Namen für diesen KI-Spieler (max 20 Zeichen)",
  insufficientPointsForFiller: "Unzureichende Punkte zum Hinzufügen eines Füllers",
  fillerAddedSuccessfully: "Füller \"{name}\" erfolgreich hinzugefügt!",
  failedToAddFiller: "Fehler beim Hinzufügen des Füllers",
  removeFiller: "Füller entfernen",
  fillerRemoved: "Füller erfolgreich entfernt!",
  fillerRemovedWithRefund: "Füller entfernt! {amount} Punkte erstattet.",
  failedToRemoveFiller: "Fehler beim Entfernen des Füllers",
  yourFiller: "(Dein Füller)",
  needMorePoints: "Du brauchst {amount} weitere Punkte",
  needMoreRealPlayers: "Du brauchst {count} weitere echte Spieler, bevor du Füller hinzufügen kannst, wenn das Turnier voll wird",
  needRealPlayersWarning: "Du brauchst {count} weitere echte Spieler, um Füller hinzuzufügen, wenn das Turnier voll wird",
  free: "KOSTENLOS",
  cost: "Kosten",
  slots: "Plätze",
  slotRemaining: "Platz übrig",
  slotsRemaining: "Plätze übrig",
  giveawayFillerFree: "Dies ist ein Giveaway-Turnier - Füller sind KOSTENLOS!",
  fillerCostWarning: "Du zahlst {cost} Punkte für diesen Füller. Wenn der Füller gewinnt, erhältst du den Preis!",
  fillerAddedAndTournamentUpdated: "Füller hinzugefügt! Turnier aktualisiert.",

  // ========== KOPIER-FUNKTIONALITÄT ==========
  noMatchIdToCopy: "Keine Match-ID zum Kopieren verfügbar",
  matchIdCopied: "Match-ID kopiert!",
  noTournamentIdToCopy: "Keine Turnier-ID zum Kopieren verfügbar",
  tournamentIdCopied: "Turnier-ID kopiert!",

  // ========== SUCHE UND SEITENNAVIGATION ==========
  searchFinishedTournaments: "Nach Turnier-ID, Ersteller, Spielmodus oder Karte suchen...",
  searchResults: "{count} Turniere gefunden",
  noSearchResults: "KEINE SUCHERGEBNISSE",
  tryDifferentSearch: "Versuche einen anderen Suchbegriff oder lösche die Suche",
  previousPage: "Vorherige Seite",
  nextPage: "Nächste Seite",
  prev: "Zurück",
  next: "Weiter",
  pageInfo: "Seite {current} von {total} ({totalItems} gesamt)",

  // ========== ADMIN-PANEL ==========
  mainAdminPanel: "Haupt-Admin-Panel",
  commissionSummary: "Provisionszusammenfassung",
  yourCommissionEarned: "Deine verdiente Provision",
  asSupervisor: "(als Supervisor)",
  asApprover: "(als Genehmiger)",
  totalFromUsers: "Gesamt von Benutzern",
  totalToApprovers: "Gesamt an Genehmiger",
  totalToSystem: "Gesamt an System",

  // ========== ADMIN-TABS ==========
  stats: "Statistiken",
  roles: "Rollen",
  pointsTab: "Punkte",
  rates: "Raten",
  users: "Benutzer",
  approvers: "Genehmiger",
  inbox: "Posteingang",
  pending: "Ausstehend",
  withdrawals: "Auszahlungen",
  transactionLog: "Transaktionen",

  // ========== TRANSAKTIONSPROTOKOLL ==========
  totalTransactions: "Gesamttransaktionen",
  pointsIn: "Punkte Ein",
  pointsOut: "Punkte Aus",
  filters: "Filter",
  hideFilters: "Ausblenden",
  showFilters: "Anzeigen",
  transactionType: "Typ",
  searchPlaceholder: "Benutzername oder Beschreibung...",
  startDate: "Startdatum",
  endDate: "Enddatum",
  apply: "Anwenden",
  reset: "Zurücksetzen",
  noTransactions: "Keine Transaktionen gefunden",
  transactionsWillAppear: "Punktetransaktionen aus Turnieren, Käufen und Admin-Aktionen erscheinen hier.",

  // ========== ROLLENVERWALTUNG ==========
  userRoleManagement: "Benutzerrollen-Verwaltung",
  joinDate: 'Beitrittsdatum',
  totalActiveTime: 'Gesamtaktivität',
  avgDailyTime: 'Tägl. Durchschnitt',
  searchUsersModifyRoles: "Suche nach Benutzern und ändere ihre Rollen. Nur Haupt-Admins können Benutzerrollen ändern.",
  searchUsers: "Benutzer suchen",
  searchByUsername: "Nach Benutzername, E-Mail oder Spielername suchen...",
  selectedUser: "Ausgewählter Benutzer",
  currentRole: "Aktuelle Rolle",
  newRole: "Neue Rolle",
  roleChangePreview: "Rollenänderung:",
  roleChangeDescription: "Benutzerrolle ändern",
  reasonForChange: "Grund für Änderung (Optional)",
  enterReasonForRoleChange: "Grund für Rollenänderung eingeben...",
  changeUserRole: "Benutzerrolle ändern",
  searchAndSelectUser: "Suche und wähle einen Benutzer, um seine Rolle zu verwalten",
  rolePermissionsGuide: "Rollenberechtigungen-Leitfaden",
  fullSystemAccess: "Voller Systemzugang, kann alle Benutzer und Einstellungen verwalten",
  canManageApprovers: "Kann Genehmiger verwalten und Turniere genehmigen",
  canApproveTournaments: "Kann Turniere genehmigen und Provision verdienen",
  managerAccess: "Supervisor-Zugang plus Benutzer sperren und Rollen verwalten",
  verifiedSponsorAccess: "Kann Giveaway- und Bracket-Turniere erstellen",
  regularUser: "Regulärer Benutzer, kann an Turnieren teilnehmen",
  cannotBeChanged: "⚠️ Kann nicht geändert werden",

  // ========== PUNKTEVERWALTUNG ==========
  pointsManagement: "Punkteverwaltung",
  searchUsersManagePoints: "Suche nach Benutzern und verwalte ihre Punkte. Du kannst Punkte hinzufügen, entfernen oder setzen.",
  actionType: "Aktionstyp",
  add: "Hinzufügen",
  remove: "Entfernen",
  set: "Setzen",
  pointsAmount: "Punktebetrag",
  enterPointsAmount: "Punktebetrag eingeben...",
  reasonOptional: "Grund (Optional)",
  enterReasonForPointsAdjustment: "Grund für Punkteanpassung eingeben...",
  actionAdd: "Hinzufügen",
  actionRemove: "Entfernen",
  actionSet: "Setzen",
  pointsToUser: "Punkte an",
  pointsFromUser: "Punkte von",
  pointsForUser: "Punkte für",
  newBalance: "Neuer Stand:",
  addPoints: "Punkte hinzufügen",
  removePoints: "Punkte entfernen",
  setPoints: "Punkte setzen",
  searchAndSelectUserPoints: "Suche und wähle einen Benutzer, um seine Punkte zu verwalten",

  // ========== PROVISIONSEINSTELLUNGEN ==========
  commissionRateSettings: "Provisionssatz-Einstellungen",
  multiplayerTournaments: "🎯 Mehrspieler-Turniere",
  battleRoyaleTournaments: "👑 Battle Royale-Turniere",
  approverCommission: "Genehmiger-Provision (%)",
  systemCommission: "System-Provision (%)",
  updateCommissionRates: "Provisionssätze aktualisieren",
  updating: "Aktualisierung...",

  // ========== BENUTZERVERWALTUNG ==========
  allUsers: "Alle Benutzer",
  ban: "Sperren",
  unban: "Entsperren",

  // ========== GENEHMIGER-VERWALTUNG ==========
  addNewApprover: "Neuen Genehmiger hinzufügen",
  multiplayerCommissionRange: "Mehrspieler-Provision (0-{max}%):",
  battleRoyaleCommissionRange: "Battle Royale-Provision (0-{max}%):",
  addAsApprover: "Als Genehmiger hinzufügen",
  adding: "Hinzufügen...",
  myApprovers: "Meine Genehmiger",
  noApproversAdded: "Noch keine Genehmiger hinzugefügt.",

  // ========== TURNIERVERWALTUNG ==========
  matchesReadyForApproval: "Matches bereit zur Genehmigung",
  youCanOnlySeeMatches: "ℹ️ Du siehst nur Matches, die nicht von anderen {role} beansprucht wurden oder die du zuvor begonnen hast zu genehmigen.",
  supervisors: "Supervisoren",
  approversLower: "Genehmigern",
  noMatchesReady: "Keine Matches bereit zur Genehmigung.",
  othersMayHaveClaimed: "Andere {role} haben möglicherweise verfügbare Matches beansprucht.",
  enterMatchIdFromCod: "Match-ID aus CoD Mobile eingeben",
  approve: "Genehmigen",
  approving: "Genehmigung...",
  startedBy: "⚠️ Gestartet von:",
  assignedToBot: 'Bot zugewiesen',

  // ========== AKTIVE MATCHES ==========
  activeMatches: "Aktive Matches",
  youCanOnlyManageMatches: "ℹ️ Du siehst und verwaltest nur Matches, die du persönlich genehmigt hast.",
  noActiveMatches: "Keine aktiven Matches.",
  haventApprovedMatches: "Du hast noch keine Matches genehmigt oder sie wurden abgeschlossen.",
  roomLabel: "🎮 Raum-ID",
  generating: "Generierung...",
  noAccess: "🔒 KEIN ZUGANG",
  notInTournament: "Nicht in diesem Turnier",
  copyId: "ID KOPIEREN",
  joinRoom: "BEITRETEN",
  roomUrl: "Raum-URL",
  enterRoomUrl: "https://... (optionaler Link zum Beitreten)",
  roomUrlDescription: "Wenn angegeben, sehen Spieler einen 'Beitreten'-Button",
  edit: "BEARBEITEN",
  cancel: "ABBRECHEN",
  standby: "⏱️ STANDBY",
  activeBadge: "🔥 AKTIV",
  joined: "✓ BEIGETRETEN",
  selectWinners: "Gewinner auswählen",
  selectWinnersPlural: "Gewinner auswählen",
  readyForSelection: "⚡ Bereit zur Auswahl",
  completeMatch: "Match abschließen",
  completing: "Abschluss...",
  winner: "Gewinner",
  winners: "Gewinner",
  teamModeInfo: "ℹ️ {mode}: Wähle {count} Gewinner aus dem siegreichen Team",
  duos: "Duos",
  squads: "Squads",
  teamMode: "Team",
  winnerSelectionAvailable: "⚡ Gewinnerauswahl ist jetzt verfügbar. Der Countdown ist nur die Frist für Spieler zum Beitreten.",

  // ========== MATCH-ID BEARBEITEN ==========
  editMatchId: "Match-ID bearbeiten",
  currentMatchId: "Aktuelle Match-ID:",
  newMatchId: "Neue Match-ID",
  enterNewMatchId: "Neue Match-ID aus CoD Mobile eingeben",
  matchIdCannotBeEmpty: "Match-ID darf nicht leer sein",
  matchIdTooLong: "Match-ID muss weniger als 50 Zeichen haben",
  sameAsCurrentMatchId: "Neue Match-ID ist gleich der aktuellen Match-ID",
  validNewMatchId: "✓ Gültige neue Match-ID",
  matchIdHistory: "Match-ID-Verlauf:",
  current: "(aktuell)",
  changingMatchIdNotification: "⚠️ Das Ändern der Match-ID benachrichtigt alle Turnierteilnehmer. Stelle sicher, dass die neue Match-ID korrekt ist.",
  updateMatchId: "Match-ID aktualisieren",
  updateMatching: "Aktualisierung...",

  // ========== TURNIER ABBRECHEN ==========
  cancelTournament: "Turnier abbrechen",
  cancellationReason: "Abbruchgrund",
  enterReasonForCancelling: "Grund für den Abbruch dieses Turniers eingeben...",
  refundInformation: "⚠️ Erstattungsinformationen:",
  creatorWillReceive: "Der Ersteller erhält",
  pointsBack: "Punkte zurück",
  eachParticipantWillReceive: "Jeder Teilnehmer erhält seine",
  entryFeeBack: "Eintrittsgebühr zurück",
  totalRefund: "Gesamterstattung",
  giveawayIndicator: "🎁 Giveaway-Turnier",
  thisActionCannotBeUndone: "⚠️ Diese Aktion kann nicht rückgängig gemacht werden. Alle Teilnehmer werden erstattet und das Turnier wird dauerhaft abgebrochen.",
  confirmCancellation: "Abbruch bestätigen",
  cancelling: "Abbruch...",
  keepTournament: "Turnier behalten",

  // ========== AUSZAHLUNGSANTRÄGE ==========
  withdrawalRequests: "Auszahlungsanträge",
  noPendingRequests: "Keine ausstehenden Anträge.",
  pointsToAmount: "{points} Punkte → ${amount}",

  // ========== BESTÄTIGUNGS-MODALS ==========
  confirmRoleChange: "Rollenänderung bestätigen",
  roleChangeFromTo: "{currentRole} → {newRole}",
  thisActionWillImmediately: "⚠️ Diese Aktion ändert sofort die Rolle und Berechtigungen des Benutzers. Der Benutzer wird über diese Änderung benachrichtigt.",
  confirmChange: "Änderung bestätigen",
  changingRole: "Rolle wird geändert...",

  // ========== PUNKTE-BESTÄTIGUNG ==========
  confirmPointsAction: "Punkte-{action} bestätigen",
  pointsAction: "Aktion:",
  actionDescription: "{action} {amount} Punkte {preposition} {username}",
  prepositionTo: "an",
  prepositionFrom: "von",
  prepositionFor: "für",
  thisActionWillUpdatePoints: "⚠️ Diese Aktion aktualisiert sofort den Punktestand des Benutzers. Stelle sicher, dass der Betrag korrekt ist.",
  confirmAction: "{action} bestätigen",
  processing: "Verarbeitung...",

  // ========== ALLGEMEINE BESTÄTIGUNG ==========
  changeUserRoleQuestion: "Rolle ändern?",
  banUserQuestion: "Benutzer sperren?",
  unbanUserQuestion: "Benutzer entsperren?",
  removeApproverQuestion: "Genehmiger entfernen?",

  // ========== BENACHRICHTIGUNGEN & NACHRICHTEN ==========
  roleChangedSuccessfully: "Rolle von {username} erfolgreich zu {role} geändert",
  pointsAddedSuccessfully: "{points} Punkte erfolgreich an {username} hinzugefügt",
  pointsRemovedSuccessfully: "{points} Punkte erfolgreich von {username} entfernt",
  pointsSetSuccessfully: "{points} Punkte erfolgreich für {username} gesetzt",
  matchIdUpdatedSuccessfully: "Match-ID erfolgreich aktualisiert",
  tournamentCancelledSuccessfully: "Turnier erfolgreich abgebrochen. {refundInfo}",
  commissionRatesUpdated: "Provisionssätze erfolgreich aktualisiert!",
  userBannedSuccessfully: "{username} wurde erfolgreich gesperrt!",
  userUnbannedSuccessfully: "{username} wurde erfolgreich entsperrt!",
  approverAddedSuccessfully: "Genehmiger erfolgreich hinzugefügt!",
  approverRemovedSuccessfully: "{username} erfolgreich aus der Genehmiger-Rolle entfernt!",
  matchApprovedSuccessfully: "Match erfolgreich genehmigt!",
  matchCompletedSuccessfully: "Match erfolgreich abgeschlossen!",
  withdrawalProcessedSuccessfully: "Auszahlungsantrag erfolgreich {status}!",

  // ========== FEHLERMELDUNGEN ==========
  failedToLoadAdminData: "Fehler beim Laden der Admin-Daten",
  failedToChangeUserRole: "Fehler beim Ändern der Benutzerrolle",
  failedToManagePoints: "Fehler bei der Punkteverwaltung",
  failedToUpdateMatchId: "Fehler beim Aktualisieren der Match-ID",
  failedToCancelTournament: "Fehler beim Abbrechen des Turniers",
  failedToUpdateCommissionRates: "Fehler beim Aktualisieren der Provisionssätze",
  failedToProcessWithdrawal: "Fehler bei der Auszahlungsverarbeitung",
  failedToSearchUsers: "Fehler bei der Benutzersuche",
  invalidUserOrRole: "Ungültiger Benutzer oder Rolle",
  userAlreadyHasRole: "Benutzer hat diese Rolle bereits",
  pleaseSelectUser: "Bitte wähle zuerst einen Benutzer",
  pleaseEnterValidAmount: "Bitte gib einen gültigen Punktebetrag ein",
  pleaseEnterMatchId: "Bitte gib eine Match-ID ein!",
  pleaseSelectWinner: "Bitte wähle mindestens einen Gewinner!",
  unknownAction: "Unbekannte Aktion: {action}",

  // ========== FORMULAR-LABELS ==========
  searchResultsCount: "Suchergebnisse ({count})",

  // ========== STATUSANZEIGEN ==========
  banned: "GESPERRT",
  approved: "GENEHMIGT",
  rejected: "ABGELEHNT",

  // ========== TURNIER ERSTELLEN ==========
  upTo: 'Bis zu',
  createTournament: "Turnier erstellen",
  tournamentType: "Turniertyp",
  regularTournament: "🏆 Reguläres Turnier",
  giveawayTournament: "🎁 Giveaway-Turnier (Kostenloser Eintritt)",

  // Giveaway Ersteller Teilnahmeoptionen
  creatorParticipation: "Ihre Teilnahme",
  joinAndPlay: "Beitreten & Spielen",
  joinAndPlayDesc: "Sie nehmen am Match teil",
  spectateGame: "Spiel Zuschauen",
  spectateGameDesc: "Das Match als Zuschauer ansehen",
  sponsorOnly: "Nur Sponsor",
  sponsorOnlyDesc: "Nur den Preis finanzieren, andere spielen",
  spectateInfo: "Sie werden als ZUSCHAUER im Spiel sein. Sie können zusehen aber nicht spielen. Alle Plätze sind für andere offen.",
  sponsorInfo: "Sie werden NICHT zum Match hinzugefügt. Alle Plätze sind für andere Spieler frei.",
  spectator: "ZUSCHAUER",

  gameMode: "Spielmodus",
  multiplayerType: "Match-Typ",
  battleRoyaleType: "Battle Royale-Typ",
  teamMatch: "Team-Match",
  customMode: "Benutzerdefiniert",
  solo: "Solo",
  duo: "Duo",
  squad: "Squad",
  team: "Team",
  entryFee: "Eintrittsgebühr",
  totalPrizePool: "Gesamtpreispool",
  roomPassword: "Raum-Passwort",
  optional: "Optional",
  estimatedPrizePool: "Geschätzter Preispool",
  totalEntryFees: "Gesamte Eintrittsgebühren",
  commission: "Provision",
  yourEntryFee: "Deine Eintrittsgebühr",
  yourTotalCost: "Deine Gesamtkosten",
  entryFeeForPlayers: "Eintrittsgebühr für Spieler",
  insufficientPoints: "Unzureichende Punkte!",
  createTournamentBtn: "Turnier erstellen",
  createRegularTournament: "Turnier erstellen",
  createGiveawayTournament: "Giveaway-Turnier erstellen",
  createQuickSolo: "Schnelles Solo erstellen",
  creating: "Erstellen...",
  minimize: "Minimieren",
  expandChat: "Chat erweitern",
  minimizeChat: "Chat minimieren",
  closeChat: "Chat schließen",
  prizePoolForWinners: "Preispool für Gewinner",
  howItWorks: "So funktioniert's",
  howItWorksQuickSolo: "Schnelles 1v1-Match auf Shipment. Erster mit {kills} Kills oder höchster Punktzahl bei {time} gewinnt!",
  howItWorksGiveaway: "Du zahlst {cost} Punkte ({prize} Preis + {commission} Provision). Spieler treten kostenlos bei. Gewinner erhalten genau {prizePool} Punkte.",
  howItWorksRegular: "Gesamte Eintrittsgebühren: {totalEntry} Pkt. Nach {commissionRate}% Provision ist der Preispool {prizePool} Pkt.",
  locked: "Gesperrt",

  // ========== SCHNELLES SOLO ==========
  quickSolo: "⚡ Schnelles Solo (1v1)",
  quickSoloTournament: "Schnelles Solo-Turnier",
  killLimit: "Kill-Limit",
  timeLimit: "Zeitlimit",
  timeLimitSeconds: "Zeitlimit (Sekunden)",
  weaponRestrictions: "Waffen-Einschränkungen (Optional)",
  selectAllowedWeapons: "Erlaubte Waffentypen auswählen (leer lassen für alle Waffen)",
  selectedWeapons: "Ausgewählte Waffentypen",
  allWeaponsAllowed: "Alle Waffen erlaubt - keine Einschränkungen",
  weaponRestrictionsWarning: "⚠️ Die Verwendung eingeschränkter Waffen führt zur sofortigen Disqualifikation!",
  allowedWeaponsOnly: "Nur diese Waffen sind erlaubt:",
  quickSoloInfo: "Schnelles Solo: Schnelle 1v1-Matches nur auf Shipment. Perfekt für schnelle Punktekämpfe!",

  // ========== WAFFENTYPEN ==========
  boltActionSniper: "Repetier-Sniper/Marksman",
  shotgun: "Schrotflinte",
  assault: "Sturmgewehr",
  smg: "SMG",

  // ========== TURNIERSTATUS ==========
  lobby: "LOBBY",
  wait: "WARTEN",
  activeStatus: "AKTIV",
  finish: "BEENDEN",
  deploying: "BEREITSTELLUNG",
  standbyStatus: "STANDBY",
  completed: "ABGESCHLOSSEN",
  cancelled: "ABGEBROCHEN",
  autoCanceled: "AUTO-ABGEBROCHEN",

  // ========== TURNIER-AKTIONEN ==========
  join: "BEITRETEN",
  abort: "ABBRECHEN",
  copy: "KOPIEREN",
  deploy: "BEREITSTELLEN",

  // ========== BR TEAM-BEITRITTS-MODAL ==========
  selectTeamPreference: "Team-Präferenz Wählen",
  selectTeam: "Wähle Dein Team",
  preference: "Präferenz",
  soloTournament: "Solo-Turnier",
  soloTournamentDesc: "Dieses Turnier erfordert, dass alle Spieler alleine spielen. Keine Teammitglieder erlaubt.",
  randomTournament: "Offenes Team-Turnier",
  randomTournamentDesc: "Jeder Spieler kann beitreten und sich mit anderen zusammentun. Wähle deine Team-Präferenz unten.",
  squadTournament: "Squad-Turnier",
  squadTournamentDesc: "Der Ersteller hat Squadmates festgelegt. Du kannst dein eigenes Squad bilden oder als Zufälliger beitreten.",
  teamTournament: "Team-Turnier",
  creatorSquadmates: "Squadmates des Erstellers:",
  duoTeamInfo: "Wähle, wie du in diesem Duo-Turnier spielen möchtest",
  squadTeamInfo: "Wähle, wie du in diesem Squad-Turnier spielen möchtest",
  yourTeamPreference: "Deine Team-Präferenz",
  soloTeam: "👤 Solo - Keine Teammitglieder",
  soloLockedReason: "Der Turnier-Ersteller hat Solo-Modus eingestellt - alle Spieler müssen alleine spielen.",
  randomTeam: "🎲 Zufällig - Jeder Spieler kann beitreten",
  squadTeam: "👥 Squad - Wähle bestimmte Teammitglieder",
  selectSquadmates: "Squadmates Auswählen",
  randomPlayer: "🎲 Zufälliger Spieler",
  playerName: "Spielername",
  specific: "Bestimmter Spieler",
  squadHelpText: "Wechsle zwischen bestimmtem Spielernamen, zufälligem Spieler oder leerem Platz",
  soloInfo: "Du wirst alleine spielen. Niemand kann deinem Team beitreten.",
  randomInfo: "Jeder verfügbare Spieler kann deinem Team beitreten.",
  selectTeamToJoin: "Wähle, welchem Team du beitreten möchtest. Als nicht verfügbar markierte Teams haben Einschränkungen.",
  randomPreference: "Zufällige Teammitglieder-Präferenz",
  squadPreference: "Squad-Präferenz",
  noAvailableTeams: "Keine verfügbaren Teams zum Beitreten. Alle Teams sind voll oder haben Einschränkungen.",
  soloPlayerTeam: "Solo-Spieler",
  squadOnly: "Nur Squad",
  available: "Verfügbar",
  spot: "Platz",
  spots: "Plätze",
  back: "Zurück",

  // ========== MP TEAM AUSWAHL ==========
  captainSettings: "Team-Kapitän Einstellungen",
  captainSettingsInfo: "Als Kapitän wähle, wer deinem Team beitreten kann",
  teamJoinMode: "Team-Beitrittsmodus",
  randomTeammates: "Zufällig - Jeder kann beitreten",
  specificTeammates: "Spezifisch - Teammitglieder wählen",
  selectTeammates: "Teammitglieder wählen (nach Spielername)",
  slot: "Slot",
  clickToEmpty: "Klicken um leer zu lassen",
  clickForRandom: "Klicken für zufällig",
  setRandom: "Zufällig setzen",
  enterInGameName: "Spielername eingeben",
  anyPlayerCanJoin: "Jeder Spieler kann diesem Slot beitreten",
  teammatesNote: "Leere Slots verhindern, dass andere beitreten können",
  randomTeamInfo: "Jeder Spieler kann deinem Team beitreten",
  youWillBeCaptain: "Du wirst Team-Kapitän sein",
  youAreInvited: "Du bist zu diesem Team eingeladen",
  joiningViaRandomSlot: "Beitritt über zufälligen Slot",
  teamNotAccepting: "Dieses Team nimmt keine Spieler an",
  notOnInviteList: "Du stehst nicht auf der Einladungsliste",
  invitedPlayers: "Eingeladene Spieler:",
  createTeam: "Team erstellen",
  mpTeamSelectInfo: "Wähle, welchem Team du für dieses Match beitreten möchtest",
  teamRestriction: "Team-Einschränkung",
  teamSelectionHeading: "Team-Auswahl",
  randomTeam: "Zufälliges Team",
  specificTeam: "Spezifisches Team",

  // ========== TURNIER-DETAILS ==========
  giveaway: "GIVEAWAY",
  highStakes: "HOHE EINSÄTZE",
  veryHighStakes: "SEHR HOHE EINSÄTZE",
  legendaryStakes: "LEGENDÄRE EINSÄTZE",
  passwordProtected: "🔒PWD",
  roomId: "🎮 RAUM",
  matchLive: "MATCH LIVE",
  tournamentId: "Turnier-ID",
  copyTournamentId: "Turnier-ID kopieren",

  // ========== TURNIER-OPERATIONEN ==========
  tournamentOps: "TURNIER-OPS",
  intelUpdated: "Intel aktualisiert!",
  noActiveLobies: "KEINE AKTIVEN LOBBYS",
  deployFirstTournament: "Stelle das erste Turnier bereit!",
  noPendingDeployments: "KEINE AUSSTEHENDEN BEREITSTELLUNGEN",
  fullLobbiesAppear: "Volle Lobbys erscheinen hier (Auto-Abbruch nach 30 Min)",
  noActiveOperations: "KEINE AKTIVEN OPERATIONEN",
  deployedTournamentsAppear: "Bereitgestellte Turniere erscheinen hier",
  noCompletedMissions: "KEINE ABGESCHLOSSENEN MISSIONEN",
  finishedCancelledAppear: "Beendete und abgebrochene Turniere erscheinen hier",
  noData: "KEINE DATEN",
  nothingToShow: "Nichts anzuzeigen",
  refresh: "AKTUALISIEREN",

  // ========== CHAT-SYSTEM ==========
  chat: "Chat",
  searchPlayers: "Spieler suchen...",
  noPlayersOnline: "Keine anderen Spieler online",
  noPlayersMatch: "Keine Spieler entsprechen deiner Suche",
  sendMessage: "Senden",
  messageUser: "Nachricht",
  typing: "schreibt...",
  connected: "Mit Server verbunden!",
  hasUnread: "hat ungelesene",
  newMessage: "Neue Nachricht",
  from: "von",
  in: "in",

  // ========== PUNKTE & PROFIL ==========
  estimatedValue: "Geschätzter Wert",
  buyPoints: "Punkte kaufen",
  withdraw: "Auszahlen",
  minimumWithdrawal: "Mindestauszahlung beträgt 1000 Punkte (1,00$)",
  profileManagement: "Profilverwaltung",
  editProfile: "Profil bearbeiten",
  changePassword: "Passwort ändern",
  updateProfile: "Profil aktualisieren",

  // ========== AUSZAHLUNG ==========
  requestWithdrawal: "Auszahlung beantragen",
  pointsToWithdraw: "Auszuzahlende Punkte",
  paypalEmail: "PayPal-E-Mail",
  youllReceive: "Du erhältst",
  platformFee: "Plattformgebühr",
  withdrawalInfo: "Auszahlungsinfo",
  minimum: "Minimum",
  submitRequest: "Antrag einreichen",
  withdrawalMinimum: "Minimum: 1000 Punkte ($9.50)",
  withdrawalFee: "Plattformgebühr: 5%",
  withdrawalProcessing: "Bearbeitung: 24-96 Stunden",
  feePercent: "5% Gebühr",
  info: "Info",
  submitting: "Wird gesendet...",
  submitting: "Einreichung...",
  leaveEmptyToUse: "Leer lassen, um deine Konto-E-Mail zu verwenden",
  withdrawalHistory: "Auszahlungsverlauf",
  noWithdrawalRequests: "Noch keine Auszahlungsanträge.",
  note: "Hinweis",

  // ========== PROFILVERWALTUNG ==========
  currentPassword: "Aktuelles Passwort",
  newPassword: "Neues Passwort",
  confirmNewPassword: "Neues Passwort bestätigen",
  enterCurrentPassword: "Aktuelles Passwort eingeben",
  enterNewPassword: "Neues Passwort eingeben (min. 6 Zeichen)",
  confirmYourNewPassword: "Neues Passwort bestätigen",
  passwordsMatch: "✓ Passwörter stimmen überein",
  passwordsDoNotMatch: "✗ Passwörter stimmen nicht überein",
  securityTips: "Sicherheitstipps",
  useAtLeast8Characters: "Mindestens 8 Zeichen verwenden",
  includeUppercaseLowercase: "Groß- und Kleinbuchstaben einbeziehen",
  addNumbersSpecialChars: "Zahlen und Sonderzeichen hinzufügen",
  dontUsePersonalInfo: "Keine persönlichen Informationen verwenden",
  changing: "Änderung...",
  makesSureThisMatches: "⚠️ Stelle sicher, dass dies genau mit deinem CoD Mobile-Spielernamen übereinstimmt!",
  passwordStrength: "Passwortstärke",
  weak: "Schwach",
  medium: "Mittel",
  strong: "Stark",
  useUppercaseLowercase: "Verwende Groß-, Kleinbuchstaben, Zahlen und Symbole für ein stärkeres Passwort",
  testCurrentPassword: "Aktuelles Passwort testen",

  // ========== SPIELVERLAUF ==========
  yourMatchHistory: "Dein Spielverlauf",
  noCompletedMatches: "Noch keine abgeschlossenen Matches.",
  joinTournamentsHistory: "Nimm an Turnieren teil, um deinen Spielverlauf aufzubauen!",
  entryFeeLabel: "Eintritt",
  prizeLabel: "Preis",
  dateLabel: "Datum",
  match: "Match",
  mode: "Modus",
  date: "Datum",
  pts: "Pkt",
  split: "Geteilt",
  ways: "Wege",
  loadingMatchHistory: "Spielverlauf wird geladen...",

  // ========== POSTEINGANG-SYSTEM ==========
  supportInbox: "Support-Posteingang",
  newReport: "Neuer Bericht",
  submitNewSupportReport: "Neuen Support-Bericht einreichen",
  subject: "Betreff",
  description: "Beschreibung",
  submitReport: "Bericht einreichen",
  noCasesYet: "Noch keine Support-Fälle",
  createNewReport: "Erstelle einen neuen Bericht, wenn du Hilfe bei Turnieren, Zahlungen oder Kontoproblemen benötigst.",
  submitFirstReport: "Ersten Bericht einreichen",
  open: "Offen",
  closed: "Geschlossen",
  beforeSubmitting: "Vor dem Einreichen:",
  beAsDetailed: "• Sei so detailliert wie möglich in deiner Beschreibung",
  includeRelevantUsernames: "• Füge relevante Benutzernamen oder Turnier-IDs hinzu",
  supportTeamWillReview: "• Unser Support-Team wird innerhalb von 24 Stunden prüfen und antworten",
  minimumCharactersRequired: "Mindestens 5 Zeichen erforderlich",
  minimum10CharactersRequired: "Mindestens 10 Zeichen erforderlich",
  submissionProcess: "Einreichungsprozess:",
  reportWillBeSubmitted: "Dein Bericht wird zunächst als geschlossen eingereicht und von unserem Support-Team geprüft. Nach der Prüfung können sie ihn wieder öffnen, um weitere Kommunikation zu ermöglichen.",
  typeYourMessage: "Nachricht eingeben...",
  sending: "Senden...",
  send: "Senden",
  pressEnterShift: "Enter + Umschalt für neue Zeile",
  caseNumber: "Fall",
  updated: "Aktualisiert",
  messages: "Nachrichten",
  clickToView: "Klicken zum Anzeigen der Konversation",
  thisCaseIsClosed: "Dieser Fall ist geschlossen. Du kannst nicht auf geschlossene Fälle antworten.",
  activeMatchDetails: "Aktive Match-Details",
  matchSettings: "🏆 Match-Einstellungen",
  teamMembers: "👥 Team-Mitglieder",
  type: "Typ",

  // ========== ADMIN-POSTEINGANG-PANEL ==========
  supportInboxManagement: "Support-Posteingang-Verwaltung",
  createCase: "Fall erstellen",
  totalCases: "Gesamtfälle",
  openCases: "Offene Fälle",
  closedCases: "Geschlossene Fälle",
  allStatus: "Alle Status",
  allAssignments: "Alle Zuweisungen",
  unassigned: "Nicht zugewiesen",
  assignedToMe: "Mir zugewiesen",
  loadingCases: "Fälle werden geladen...",
  noCasesFound: "Keine Fälle gefunden",
  adjustFiltersOrCreateCase: "Passe Filter an oder erstelle einen neuen Fall für einen Benutzer",

  // Fehlende Kernübersetzungen
  unknown: "Unbekannt",
  mins: "Min",
  hrs: "Std",
  daysShort: "T",
  ago: "vor",
  warning: "Warnung",
  view: "Ansehen",
  viewCase: "Ansehen",
  created: "Erstellt",
  createNewCaseForUser: "Neuen Fall für Benutzer erstellen",
  selectUser: "Benutzer auswählen",
  searchUsersUsername: "Nach Benutzername, E-Mail oder Spielername suchen...",
  selected: "Ausgewählt:",
  initialMessage: "Erste Nachricht",
  caseSubject: "Fall-Betreff...",
  initialMessageToUser: "Erste Nachricht an den Benutzer...",
  createCaseBtn: "Fall erstellen",
  closeCase: "Fall schließen",
  openCase: "Fall öffnen",
  assignToMe: "Mir zuweisen",
  unassignCase: "Zuweisung aufheben",
  deleteCase: "Fall löschen",
  assignedTo: "Zugewiesen an:",
  systemMessage: "System",
  typeYourResponse: "Antwort eingeben...",
  deleteCaseModal: "Fall löschen",
  deleteCaseWarning: "Warnung:",
  deleteCaseText: "Diese Aktion kann nicht rückgängig gemacht werden. Der Fall und alle Nachrichten werden dauerhaft gelöscht.",
  deleting: "Löschen...",
  youAreCurrentlyViewing: "📝 Du siehst gerade diesen Fall",
  youAreViewingCasesList: "📋 Du siehst die Fallliste",
  afterDeletionReturn: "Nach dem Löschen kehrst du zur Fallliste zurück",
  listWillRefresh: "Die Liste wird nach dem Löschen aktualisiert",
  caseLabel: "Fall:",
  userLabel: "Benutzer:",
  messagesLabel: "Nachrichten:",
  newReportFrom: "Neuer Bericht von {user}: {subject}",
  newMessageInCase: "Neue Nachricht in Fall {caseNumber}",
  caseAssignedToYou: "Fall {caseNumber} dir zugewiesen",
  pleaseFillAllFields: "Bitte alle Felder ausfüllen",
  caseCreatedSuccessfully: "Fall erfolgreich erstellt",
  failedToCreateCase: "Fehler beim Erstellen des Falls",
  pleaseEnterMessage: "Bitte Nachricht eingeben",
  failedToSendMessage: "Fehler beim Senden der Nachricht",
  caseStatusSuccessfully: "Fall erfolgreich {status}",
  failedToUpdateCaseStatus: "Fehler beim Aktualisieren des Fallstatus",
  caseAssignedSuccessfully: "Fall erfolgreich zugewiesen",
  caseUnassignedSuccessfully: "Fallzuweisung erfolgreich aufgehoben",
  failedToAssignCase: "Fehler beim Zuweisen des Falls",
  caseDeletedSuccessfully: "Fall erfolgreich gelöscht",
  failedToDeleteCase: "Fehler beim Löschen des Falls",
  noCaseSelectedForDeletion: "Kein Fall zum Löschen ausgewählt",
  noCaseSelected: "Kein Fall ausgewählt",
  reasonForClosing: "Grund für das Schließen dieses Falls:",
  reasonForOpening: "Grund für das Öffnen dieses Falls:",
  closing: "Schließen",
  opening: "Öffnen",
  assignment: "Zuweisung",
  status: "Status",
  user: "Benutzer",
  createdLabel: "Erstellt",
  updatedLabel: "Aktualisiert",
  emptyStateTitle: "Keine Fälle gefunden",
  emptyStateText: "Passe Filter an oder erstelle einen neuen Fall für einen Benutzer",

  // ========== POSTEINGANG-FEHLERMELDUNGEN ==========
  failedToLoadInbox: "Fehler beim Laden des Posteingangs",
  failedToLoadCase: "Fehler beim Laden des Falls",
  pleaseFillBothFields: "Bitte Betreff und Beschreibung ausfüllen",
  subjectMinLength: "Betreff muss mindestens 5 Zeichen haben",
  descriptionMinLength: "Beschreibung muss mindestens 10 Zeichen haben",
  reportSubmittedSuccessfully: "Bericht erfolgreich eingereicht",
  failedToSubmitReport: "Fehler beim Einreichen des Berichts",
  messageTooLong: "Nachricht zu lang (max 1000 Zeichen)",
  briefDescriptionPlaceholder: "Kurze Beschreibung deines Problems...",
  detailedDescriptionPlaceholder: "Bitte gib detaillierte Informationen zu deinem Problem an, einschließlich relevanter Benutzernamen, Turnier-IDs oder Schritten zur Reproduktion des Problems...",
  hasBeenLabel: "wurde",
  reopened: "wieder geöffnet",
  yourCase: "Dein Fall",
  hasBeenDeleted: "wurde gelöscht von",

  // ========== ZAHLUNGSSYSTEM ==========
  buyTournamentPoints: "Turnierpunkte kaufen",
  chooseYourPerfectPackage: "Wähle dein perfektes Paket und starte den Wettkampf!",
  selectYourPackage: "Wähle dein Paket",
  chooseTheAmountOfPoints: "Wähle die Punktemenge, die zu deinen Gaming-Bedürfnissen passt",
  instantDelivery: "Sofortige Lieferung",
  securePayment: "Sichere Zahlung",
  noExpiration: "Kein Ablaufdatum",
  securePaymentInfo: "Sichere Zahlungsinformationen",
  processingPayment: "Zahlung wird verarbeitet...",
  yourPaymentProcessedSecurely: "Deine Zahlung wird sicher über PayPal verarbeitet",
  pointsAddedInstantly: "Punkte werden sofort deinem Konto hinzugefügt",
  allTransactionsEncrypted: "Alle Transaktionen sind verschlüsselt und sicher",
  noHiddenFeesOrCharges: "Keine versteckten Gebühren",
  pointsPerDollar: "Punkte pro $",

  // ========== PAKETBESCHREIBUNGEN ==========
  perfectForTryingOut: "Perfekt zum Ausprobieren",
  bestValueForBeginners: "Bestes Preis-Leistungs-Verhältnis für Anfänger",
  seriousPlayersChoice: "Wahl ernsthafter Spieler",
  tournamentReady: "Turnierbereit",
  competitiveEdge: "Wettbewerbsvorteil",
  proTournamentBundle: "Pro-Turnier-Paket",
  maximumValuePack: "Maximalwert-Paket",

  // ========== PAKET-BADGES ==========
  starter: "Starter",
  basic: "Basic",
  mostPopular: "Beliebteste",
  greatValue: "Toller Wert",
  powerPack: "Power-Paket",
  ultimate: "Ultimate",
  megaPack: "Mega-Paket",

  // ========== KAUFANLEITUNG ==========
  howToPurchase: "Wie kaufen",
  selectPackage: "Paket auswählen",
  chooseYourPreferredPackage: "Wähle oben dein bevorzugtes Punktepaket",
  clickPayPal: "PayPal klicken",
  proceedWithSecureCheckout: "Fahre mit dem sicheren PayPal-Checkout fort",
  completePayment: "Zahlung abschließen",
  finishTransactionViaPayPal: "Transaktion über PayPal abschließen",
  pointsAddedImmediatelyToAccount: "Punkte werden sofort deinem Konto hinzugefügt",

  // ========== TURNIERMODI ==========
  snipersOnly: "NUR SNIPER",
  rifleOnly: "NUR GEWEHRE",
  knifeOnly: "NUR NAHKAMPF",
  executionOnly: "NUR HINRICHTUNG",
  grenadesOnly: "NUR SPRENGSTOFF",
  snipers: "SNIPER",
  rifles: "GEWEHRE",
  melee: "NAHKAMPF",
  execution: "HINRICHTUNG",
  explosives: "SPRENGSTOFF",
  custom: "Benutzerdefiniert",
  ffa: "JgJ",

  // ========== SPIELMODI ==========
  teamDeathmatch: "⚔️ Team-Deathmatch",
  domination: "🏁 Herrschaft",
  searchAndDestroy: "💣 Suchen und Zerstören",
  hardpoint: "📍 Hardpoint",
  killConfirmed: "🏷️ Kill bestätigt",
  captureTheFlag: "🚩 Flagge erobern",
  frontline: "⚡ Frontlinie",
  freeForAll: "🎯 Jeder gegen Jeden",
  gunGame: "🔫 Gun Game",
  sticksAndStones: "Stöcke und Steine",
  oneShotOneKill: "🎯 Ein Schuss, ein Kill",
  cranked: "⚡ Cranked",
  rapidFire: "💨 Schnellfeuer",
  attackOfTheUndead: "🧟 Angriff der Untoten",

  // ========== ALLGEMEINE LABELS ==========
  tournament: "Turnier",
  random: "Zufällig",

  // ========== KARTEN ==========
  randomMap: "🎲 Zufällige Karte",

  // ========== PASSWORT-MODAL ==========
  passwordProtectedTournament: "🔒 PASSWORTGESCHÜTZTES TURNIER 🔒",
  tournamentPasswordProtected: "Dieses Turnier ist passwortgeschützt. Du brauchst das richtige Passwort zum Beitreten.",
  enterPassword: "Passwort eingeben",

  // ========== SPERR-MODAL ==========
  accountBanned: "🚫 Konto gesperrt 🚫",
  accountBannedDesc: "Dein Konto wurde gesperrt und kann sich nicht anmelden.",
  bannedBy: "Gesperrt von",
  contactSupport: "Kontaktiere den Support, wenn du glaubst, dies ist ein Fehler.",
  understood: "Verstanden",

  // ========== FORMULARVALIDIERUNG ==========
  fieldRequired: "Dieses Feld ist erforderlich",
  invalidEmail: "Bitte gib eine gültige E-Mail-Adresse ein",
  passwordTooShort: "Passwort muss mindestens 6 Zeichen haben",
  usernameMinLength: "Benutzername muss mindestens 3 Zeichen haben",
  usernameMaxLength: "Benutzername darf maximal 20 Zeichen haben",
  invalidCharacters: "Enthält ungültige Zeichen",
  fieldTooLong: "Dieses Feld ist zu lang",
  fieldTooShort: "Dieses Feld ist zu kurz",
  numberRequired: "Bitte gib eine gültige Zahl ein",
  numberTooLow: "Zahl ist zu niedrig",
  numberTooHigh: "Zahl ist zu hoch",

  // ========== ALLGEMEINE FEHLER & NACHRICHTEN ==========
  error: "Fehler",
  success: "Erfolg",
  info: "Info",
  failed: "Fehlgeschlagen",
  retry: "Erneut versuchen",
  confirm: "Bestätigen",

  // ========== ALLGEMEINE AKTIONEN ==========
  save: "Speichern",
  delete: "Löschen",
  update: "Aktualisieren",
  submit: "Einreichen",
  reject: "Ablehnen",

  // ========== FEHLENDE ADMIN-ÜBERSETZUNGEN ==========
  banUser: "Benutzer sperren",
  unbanUser: "Benutzer entsperren",
  removeApprover: "Genehmiger entfernen",
  failedToApproveMatch: "Fehler beim Genehmigen des Matches",
  failedToCompleteMatch: "Fehler beim Abschließen des Matches",
  startsIn: "Startet in",

  // ========== ZEIT & DATUM ==========
  now: "jetzt",
  today: "heute",
  yesterday: "gestern",
  timeUntilAutoCancel: "Min bis Auto-Abbruch",
  timeRemaining: "Min übrig",

  // ========== BENACHRICHTIGUNGEN ==========
  tournamentCreated: "Turnier erfolgreich erstellt!",
  joinedTournament: "Turnier erfolgreich beigetreten!",
  leftTournament: "Turnier erfolgreich verlassen!",
  profileUpdated: "Profil erfolgreich aktualisiert!",
  passwordChanged: "Passwort erfolgreich geändert!",
  connectionRestored: "Serververbindung wiederhergestellt",
  reconnecting: "Verbindung zum Server wird wiederhergestellt...",
  tournamentApproved: "Turnier genehmigt von",
  tournamentCompleted: "Turnier abgeschlossen von",
  tournamentCancelled: "Turnier abgebrochen von",
  tournamentAutoCancelled: "Turnier auto-abgebrochen: {tournamentName}",
  createdGiveawayTournament: "hat ein GIVEAWAY-Turnier in der Lobby erstellt!",
  createdNewMatch: "hat ein neues Match in der Lobby erstellt!",
  isNowOnline: "ist jetzt online!",
  commissionDistributed: "Provision verteilt!",
  commissionUpdated: "Provisionseinstellungen aktualisiert!",

  // ========== ZUSÄTZLICHE STRINGS ==========
  participants: "Teilnehmer",
  insufficientPointsDetailed: "Unzureichende Punkte! Du brauchst {needed} Punkte, hast aber nur {current} Punkte.",
  giveawayExplanation: "Bei Giveaway-Turnieren zahlst du {prize} Punkte (Preis) + {commission} Punkte (Provision) = {total} gesamt",
  disobeyingWeaponRules: "⚠️ Missachtung der Waffenregeln führt zu sofortigem Punktverlust!",
  estimatedPrizePoolCalculation: "Geschätzter Preispool",
  baseCommission: "🏛️ Grundprovision",
  highKillBonus: "⚡ High-Kill-Bonus",
  totalCommission: "📊 Gesamtprovision",
  extraCommissionFromHighKills: "Extra {rate}% Provision für hohe Killzahl geht an den Genehmiger.",
  failedToLoadTournaments: "Fehler beim Laden der Turniere",
  system: "System",

  // ========== TURNIERKARTEN-SPEZIFISCH ==========
  participantsCount: "{current}/{max}",
  prizeFormat: "🏆{amount}",
  entryFormat: "💰{amount}",
  killsFormat: "💀{amount}K",
  modeFormat: "⚔️{mode}",
  mapFormat: "📍{map}",
  teamFormat: "👥{count}",
  timeFormat: "⏰{time}",
  dateFormat: "📅{date}",

  // ========== WARTEZEIT-WARNUNGEN ==========
  warningAutoCancel: "⚠️ {time}Min bis Auto-Abbruch",
  warningTimeRemaining: "⏰ {time}Min übrig",

  // ========== AKTIVES MATCH ==========
  gameSettings: "Spieleinstellungen",
  prizePool: "Preispool",

  // ========== BEENDETE TURNIERE ==========
  autoCancel: "AUTO-ABGEBROCHEN",
  canceled: "ABGEBROCHEN",
  cancelledBy: "Abgebrochen von",
  more: "mehr",
  approvedBy: "Genehmigt von",

  // ========== TURNIER-FIXES ==========
  failedToCreateTournament: "Fehler beim Erstellen des Turniers",
  matchType: "Match-Typ",

  // ========== FRÜHSTART-ABSTIMMUNG ==========
  voteToStart: "Zum Starten abstimmen",
  earlyStartVoting: "Frühstart-Abstimmung",
  voteForEarlyStart: "Für Frühstart abstimmen",
  removeVote: "Stimme entfernen",
  votesNeeded: "Benötigte Stimmen",
  allPlayersVoted: "Alle Spieler haben abgestimmt!",
  waitingForVotes: "Warte auf Stimmen...",
  prizeWillChange: "⚠️ Der Preis wird sich ändern, da die Lobby nicht voll ist",
  currentPrize: "Aktueller Preis",
  newPrize: "Neuer Preis",
  youVoted: "✓ Abgestimmt",
  voteRegistered: "Deine Stimme wurde registriert!",
  voteRemoved: "Deine Stimme wurde entfernt",
  failedToVote: "Fehler beim Registrieren der Stimme",

  // ========== GIVEAWAY-STEUERUNG ==========
  instantStart: "Sofortstart",
  requestVote: "Abstimmung anfordern",
  giveawayCreatorControls: "Giveaway-Ersteller-Steuerung",
  startInstantly: "Sofort starten",
  initiateVote: "Abstimmung starten",

  // ========== MEHRSTUFIGES TURNIER ==========
  multistepTournaments: "Mehrstufige Turniere",
  multistepTournament: "Mehrstufiges Turnier",
  createBracketTournament: "Mehrstufiges Turnier erstellen",
  createBracket: "Erstellen",
  noBracketTournaments: "Noch keine mehrstufigen Turniere",
  bracketTournamentCreated: "Mehrstufiges Turnier erstellt!",
  numberOfTeams: "Anzahl Teams",
  costSummary: "Kostenübersicht",
  prizePerWinner: "Preis pro Gewinner",
  confirmCreate: "Turniererstellung bestätigen",
  viewBracket: "Spielplan",
  tournamentBracket: "Turnierspielplan",
  joinedTeam: "Team erfolgreich beigetreten!",
  tournamentStarted: "Das Turnier hat begonnen!",
  confirmWinner: "Dieses Team als Gewinner festlegen?",
  yourTeam: "Dein Team",
  registration: "ANMELDUNG",
  final: "Finale",
  semiFinals: "Halbfinale",
  quarterFinals: "Viertelfinale",
  round: "Runde",
  matches: "Spiele",
  tbd: "TBD",
  clickToSelectWinner: "Klicke auf Team um Gewinner auszuwählen",
  perWinner: "Pro Gewinner",
  tournamentWinners: "Turniergewinner",
  full: "VOLL",
  showTeams: "Teams anzeigen",
  hideTeams: "Teams ausblenden",
  startTournament: "Starten",
  viewAllTeams: "Alle Teams & Spiele",
  allTeamsMatchups: "Alle Teams & Spiele",
  teams: "Teams",
  activeBracketMatches: "Aktive Bracket-Spiele",
  configureMatch: "Spiel konfigurieren",
  configureMatchups: "Spiele konfigurieren",
  startMatch: "Spiel starten",
  applications: "Bewerbungen",
  pendingTeams: "Wartende Teams",
  approvedTeams: "Genehmigte Teams",
  pendingApplications: "Ausstehende Bewerbungen",
  noApplications: "Keine ausstehenden Bewerbungen",
  noApprovedTeamsYet: "Noch keine genehmigten Teams",
  pendingTeamsApproval: "Teams warten auf Genehmigung",
  pendingTeamsInfo: "Diese Teams warten auf Genehmigung",
  approveTeam: "Genehmigen",
  rejectTeam: "Ablehnen",
  teamApproved: "Team genehmigt!",
  teamRejected: "Team abgelehnt und entfernt",
  applicationApproved: "Bewerbung genehmigt!",
  applicationRejected: "Bewerbung abgelehnt",
  errorApprovingTeam: "Fehler beim Genehmigen des Teams",
  errorRejectingTeam: "Fehler beim Ablehnen des Teams",
  errorApproving: "Fehler beim Genehmigen",
  errorRejecting: "Fehler beim Ablehnen",
  applyToTournament: "Für Turnier bewerben",
  applyToJoin: "Zum Beitritt bewerben",
  applyToTeam: "Bewerben",
  applying: "Bewerbung wird gesendet...",
  applied: "Beworben",
  teamApplied: "Teambewerbung eingereicht! Warte auf Admin-Genehmigung.",
  applicationSubmitted: "Bewerbung eingereicht! Warte auf Admin-Genehmigung.",
  applicationPending: "Deine Bewerbung für",
  isPending: "wartet auf Genehmigung",
  awaitingApproval: "Warte auf Genehmigung",
  createNewTeam: "Neues Team erstellen",
  youAreCaptain: "Du bist der Team-Kapitän!",
  captainInfo: "Als Kapitän kannst du festlegen, wer deinem Team beitreten kann.",
  teamPreferences: "Team-Einstellungen",
  setPreferencesFirst: "Wähle zuerst ein Team",
  captain: "Kapitän",
  teamName: "Teamname",
  enterTeamName: "Teamname eingeben",
  teammates: "Teammitglieder",
  teammate: "Teammitglied",
  teammatesHint: "Gib die Benutzernamen deiner 4 Teammitglieder ein",
  teammatesUpdated: "Teammitgliedernamen aktualisiert!",
  editTeammates: "Teammitgliedernamen bearbeiten",
  editTeammateNames: "Teammitgliedernamen bearbeiten",
  editNames: "Namen bearbeiten",
  editHint: "Aktualisiere die Benutzernamen deiner Teammitglieder",
  saveChanges: "Änderungen speichern",
  saving: "Speichern...",
  need4Teammates: "Du musst alle 4 Teammitglieder angeben",
  needMoreTeammates: "Du brauchst mehr Teammitgliedernamen",
  duplicateNames: "Teammitgliedernamen müssen einzigartig sein",
  dontIncludeYourself: "Füge dich selbst nicht zur Teammitgliederliste hinzu",
  errorCreatingTeam: "Fehler beim Erstellen des Teams",
  yourAllowedSquadmates: "Deine erlaubten Teammitglieder",
  noSquadmatesSet: "Keine Teammitglieder festgelegt - jeder kann deinem Team beitreten",
  edit: "Bearbeiten",
  save: "Speichern",
  saving: "Speichern...",
  errorUpdating: "Fehler beim Aktualisieren der Teammitglieder",
  joinThisTeam: "Team beitreten",
  joinYourTeam: "Deinem Team beitreten",
  leaveTeam: "Team verlassen",
  confirmLeave: "Bist du sicher, dass du gehen möchtest?",
  errorJoining: "Fehler beim Beitreten des Teams",
  errorLeaving: "Fehler beim Verlassen",
  kickPlayer: "Spieler entfernen",
  kickTeam: "Team kicken/disqualifizieren",
  playerKicked: "Spieler aus Team entfernt",
  teamKicked: "Team wurde gekickt",
  confirmKick: "Diesen Spieler aus deinem Team entfernen?",
  enterKickReason: "Grund für das Kicken/Disqualifizieren dieses Teams eingeben:",
  errorKicking: "Fehler beim Entfernen des Spielers",
  errorKickingTeam: "Fehler beim Kicken des Teams",
  invited: "Eingeladen",
  inviteOnly: "Nur auf Einladung",
  yourNameInvited: "Dein Name muss in der Einladungsliste sein um beizutreten",
  waiting: "wartend",
  waitingToJoin: "wartet auf Beitritt",
  captain: "Kapitän",
  totalSlots: "Gesamtplätze",
  alreadyJoined: "Bereits beigetreten",
  allTeamsTaken: "Alle Teams vergeben",
  teamsReady: "Teams bereit",
  teamsWaitingForYou: "Teams warten auf dich",
  applyHint: "Bewirb dich bei einem bestehenden Team oder erstelle dein eigenes",
  applyHintAdmin: "Erstelle Teams und konfiguriere Spiele",
  createHintFull: "Alle Teamplätze sind belegt",
  enterRoomId: "Raum-ID eingeben",
  customMap: "Benutzerdefinierte Karte",
  enterCustomMapName: "Benutzerdefinierte Karte eingeben",
  matchStarted: "Das Spiel hat begonnen!",
  errorStartingMatch: "Fehler beim Starten des Spiels",
  confirmStart: "Turnier starten? Teams werden gesperrt.",
  errorStarting: "Fehler beim Starten des Turniers",
  selectWinner: "Gewinner auswählen",
  errorSettingWinner: "Fehler beim Festlegen des Gewinners",
  cancelReason: "Grund für die Absage:",
  errorCancelling: "Fehler beim Absagen",
  firstRoundMatchups: "Erste Runde Spiele",
  matchupHint: "Konfiguriere welche Teams gegeneinander spielen",
  saveMatchups: "Spiele speichern",
  selectBothTeams: "Bitte wähle beide Teams für alle Spiele",
  duplicateTeam: "Jedes Team kann nur einmal verwendet werden",
  matchupsConfigured: "Spiele erfolgreich konfiguriert!",
  errorConfiguringMatchups: "Fehler beim Konfigurieren der Spiele",
  adjustSizeTo: "Anpassen auf",
  confirmAdjustSize: "Spielplangröße anpassen? Dies wird die Struktur neu generieren.",
  bracketAdjusted: "Spielplan angepasst",
  errorAdjustingSize: "Fehler beim Anpassen der Spielplangröße",
  allTeamsApproved: "Alle Teams genehmigt",
  approveAllTeams: "Alle Teams genehmigen",
  confirmApproveAll: "Alle wartenden Teams genehmigen?",
  reroll: "Neu würfeln",
  rerollMatchup: "Zufälliger Tausch",
  other: "Andere",
  otherMatchup: "Team zum Tauschen auswählen",
  selectTeamToSwap: "Team zum Tauschen auswählen:",
  teamSwapped: "Team getauscht!",
  errorSwappingTeam: "Fehler beim Tauschen des Teams",
  or: "oder",
  fillAllFields: "Bitte fülle alle Felder aus",
  required: "Erforderlich",
  prizeSummary: "Preisübersicht",
  freeForAdmins: "Kostenlos für Admins",
  gameModePerMatch: "Spielmodus und Karte werden für jedes Spiel einzeln konfiguriert",
  each: "jeweils",
  starting: "Starten...",
  pendingApproval: "ausstehend",

  // ========== VOTE TO START EARLY ==========
  voteEarlyStart: "Für Frühstart abstimmen",
  voteToStart: "Für Frühstart abstimmen",
  voteToStartEarly: "Für frühen Turnierstart abstimmen",
  voteRecorded: "Stimme aufgezeichnet! ({current}/{total})",
  voteRemoved: "Stimme entfernt",
  voteRequestSent: "Abstimmungsanfrage an alle Teilnehmer gesendet!",
  voteInProgress: "Abstimmung läuft ({current}/{total})",
  vote: "ABSTIMMEN",
  earlyPrize: "Frühstart",
  votesNeeded: "Stimmen benötigt",
  votedPlayers: "Abgestimmte Spieler",
  voteRequestSentWaiting: "Abstimmungsanfrage gesendet! Warte auf Spieler...",
  voteNote: "Turnier startet automatisch wenn alle echten Spieler abstimmen.",
  voteNoteGiveaway: "Bei Giveaway-Matches muss der Ersteller das Match manuell starten nachdem alle abgestimmt haben.",

  // ========== CREATE TOURNAMENT TEAM PREFERENCE ==========
  teamPreference: "Team-Präferenz",
  randomAnyPlayerCanJoin: "Zufällig - Jeder Spieler kann deinem Team beitreten",
  specificChooseTeammates: "Spezifisch - Wähle deine Teammitglieder",
  emptySlotOptional: "Leerer Slot (Optional)",
  enterPlayerInGameName: "Spieler In-Game Name eingeben",

  // ========== BR EDIT TEAM ==========
  editTeam: "Team bearbeiten",
  viewTeam: "Team anzeigen",
  viewPlayers: "Spieler anzeigen",
  viewTeamPositions: "Team Positionen",
  editAllowedTeammates: "Erlaubte Teammitglieder bearbeiten",
  teammatesHint: "Geben Sie die Namen der Spieler ein, die Ihrem Team beitreten dürfen. Lassen Sie leer oder setzen Sie auf zufällig, um jeden zuzulassen.",
  mpTeammatesHint: "Geben Sie Spielernamen ein, um bestimmte Spieler zuzulassen. Verwenden Sie 🎲 für zufällige Spieler. Leere Plätze sind gesperrt.",
  specificPreference: "Spezifischer Modus - Nur benannte Spieler können beitreten",
  captain: "Kapitän",
  specific: "SPEZIFISCH",
  lockedSlot: "Gesperrter Platz",
  lockedSlotInfo: "🔒 Gesperrt - niemand kann beitreten",
  openSlot: "Offener Platz",
  waitingFor: "Warten auf",
  unlockSlot: "Platz entsperren (zufällig erlauben)",
  lockSlot: "Platz sperren",

  // ========== KICK PLAYER MODAL ==========
  kickPlayerTitle: "Spieler entfernen",
  kickPlayerConfirm: "Bist du sicher, dass du diesen Spieler entfernen möchtest?",
  kickFillerConfirm: "Diesen Filler aus dem Turnier entfernen?",
  removeFromTournament: "Aus Turnier entfernen",
  kickReason: "Grund (optional)",

  // ========== MP TEAM SELECTION ==========
  teamSelection: "Team-Auswahl",
  selectTeam: "Wähle dein Team",
  mpTeamSelectInfo: "Wähle welchem Team du in diesem Match beitreten möchtest",
  youWillBeCaptain: "Du wirst Team-Kapitän sein",
  youAreInvited: "Du bist in dieses Team eingeladen",
  joiningViaRandomSlot: "Beitritt über zufälligen Slot",
  teamNotAccepting: "Dieses Team nimmt keine Spieler auf",
  squadOnly: "Nur Squad",
  spotsAvailable: "Plätze verfügbar",
  captainSettings: "Team-Kapitän Einstellungen",
  captainSettingsInfo: "Als Team-Kapitän wähle wer deinem Team beitreten kann",
  teamJoinMode: "Team-Beitritts-Modus",
  randomTeammate: "🎲 Zufällig - Jeder Spieler kann deinem Team beitreten",
  specificTeammate: "👥 Spezifisch - Wähle deine Teammitglieder",
  slot: "Slot",
  clickToEmpty: "Klicke um leer zu lassen",
  clickForRandom: "Klicke für zufällig",
  random: "Zufällig",
  setRandom: "Zufällig setzen",
  anyPlayerCanJoin: "Jeder Spieler kann diesem Slot beitreten",
  teammatesNote: "Lasse Slots leer um andere daran zu hindern deinem Team beizutreten",
  joining: "Beitritt...",
  createTeam: "Team erstellen",
  joinTeam: "Team beitreten",
  editTeamPreferences: "Team-Einstellungen bearbeiten",
  viewAllTeamPositions: "Alle Team-Positionen anzeigen",
  emptySlot: "Leerer Slot",
  enterPlayerInGameName: "Spieler In-Game Name eingeben",
  enterNameOrSetRandom: "Name eingeben oder zufällig setzen",
  enterExactInGameName: "Gib den genauen In-Game Namen deines Teammitglieds ein, oder setze auf zufällig",
  editAllowedSquadmates: "Erlaubte Squadmitglieder bearbeiten",
  squadPreference: "Squad-Modus - Nur bestimmte Teammitglieder",
  randomPreference: "Zufalls-Modus - Jeder kann beitreten",
  squadmatesHint: "Gib die Namen der Spieler ein, die deinem Team beitreten dürfen. Lasse leer oder setze auf zufällig um jeden zuzulassen.",
  slot: "Slot",
  anyoneCanJoin: "Jeder kann diesem Slot beitreten",
  emptySlotInfo: "Leer - niemand kann diesen Slot nutzen",
  specificPlayer: "Nur dieser Spieler kann beitreten",
  clearSlot: "Slot leeren",
  randomPlayer: "Zufälliger Spieler",
  enterPlayerName: "Spielernamen eingeben...",
  playerName: "Spielername",
  saveChanges: "Änderungen speichern",
  saving: "Speichern...",

  // ========== VOTE EARLY START MODAL ==========
  prizeReductionWarning: "Preisreduzierungs-Warnung",
  lobbyNotFull: "Lobby ist nicht voll ({current}/{max} Spieler)",
  current: "Aktuell",

  // ========== KICK PLAYER MODAL EXTRAS ==========
  kick: "Kicken",
  realPlayer: "Echter Spieler",
  fillerPlayer: "Filler Spieler",
  fillerBot: "Filler Bot",
  playerWillReceiveRefund: "Spieler erhält {amount} Punkte Rückerstattung",
  thisActionIsPermanent: "Diese Aktion ist dauerhaft",
  playerWillBeRemoved: "Dieser Spieler wird aus dem Turnier entfernt und kann nicht wieder beitreten.",
  tournamentInformation: "Turnier-Information",
  currentPlayers: "Aktuell: {current}/{max} Spieler",
  kickParticipant: "{type} kicken",
  player: "Spieler",
  filler: "Filler",
  yourFiller: "Dein Filler",
  youAddedThis: "Du hast diesen Filler hinzugefügt",
  othersFiller: "Filler von jemand anderem",
  addedBySomeoneElse: "Von einem anderen Spieler hinzugefügt",
  refundInformation: "Rückerstattungs-Information",
  playerRefund: "Spieler erhält {amount} Punkte Rückerstattung",
  fillerRefund: "Filler-Besitzer erhält {amount} Punkte Rückerstattung",
  fillerRefundNote: "Rückerstattung geht an die Person, die den Filler hinzugefügt hat",
  permanentAction: "Diese Aktion ist dauerhaft",
  playerKickWarning: "Dieser Spieler wird aus dem Turnier entfernt und kann nicht wieder beitreten.",
  fillerKickWarning: "Dieser Filler wird aus dem Turnier entfernt und kann nicht erneut hinzugefügt werden.",
  tournamentInfo: "Turnier-Information",
  currentParticipants: "Aktuell: {current}/{max} Spieler",
  currentFillers: "Filler: {count}",
  kicking: "Kicken...",
  confirmKick: "{type} kicken",
  // Subscription translations
  
  
  // ========== MP MULTISTEP & ADDITIONAL ==========
  mpMultistep: "MP Mehrstufig",
  mpMultistepDesc: "Teambasiertes Multiplayer-Turnier mit Bracket-Fortschritt. 5 Spieler pro Team.",
  teamsCount: "4, 8 oder 16 Teams",
  bracketElimination: "Ausscheidungs-Bracket-Format",
  gameModePerMatch: "Spielmodus pro Match festgelegt",
  soloSquadModes: "Solo-, Duo- oder Trupp-Modi",
  roundsRange: "2-5 Runden",
  cumulativePoints: "Kumulative Punkte aus Kills + Platzierung",
  pts: "Pkt",
// ========== BR MULTISTEP TOURNAMENT ==========
  brMultistep: "BR Mehrstufig",
  brMultistepDesc: "Battle Royale Turnier mit mehreren Runden",
  br_multistep: "BR Mehrstufig",
  createBRMultistep: "BR Mehrstufig Turnier erstellen",
  brMultistepCreated: "BR Mehrstufig Turnier erfolgreich erstellt",
  solo: "Solo",
  soloDesc: "Einzelne Spieler treten an",
  duo: "Duo",
  duoDesc: "Teams mit 2 Spielern",
  squad: "Trupp",
  squadDesc: "Teams mit 4 Spielern",
  controlMode: "Steuerungsmodus",
  control: "Steuerung",
  manual: "Manuell",
  manualDesc: "Admin verwaltet Räume manuell",
  bot: "Bot",
  botDesc: "Bot erstellt und verwaltet Räume automatisch",
  botIdle: "Bot wartet",
  botCreatingRoom: "Raum wird erstellt...",
  botRoomReady: "Raum bereit",
  botWaitingPlayers: "Warte auf Spieler",
  botMatchActive: "Spiel läuft",
  botExtractingResults: "Ergebnisse werden extrahiert",
  botRoundComplete: "Runde abgeschlossen",
  botError: "Bot-Fehler",
  botReconnected: "Bot wieder verbunden",
  numberOfRounds: "Anzahl der Runden",
  rounds: "Runden",
  scheduledStart: "Geplanter Start",
  scheduledStartHint: "Wann das Turnier beginnen soll",
  pointsConfiguration: "Punktekonfiguration",
  pointsPerKill: "Punkte pro Kill",
  perKill: "pro Kill",
  placementPoints: "Platzierungspunkte",
  placementHint: "Punkte basierend auf der Endplatzierung",
  addPlacement: "Platzierung hinzufügen",
  place: "Platz",
  pointsDistribution: "Punkteverteilung",
  teams: "Teams",
  allTeams: "Alle Teams",
  noTeamsYet: "Noch keine Teams",
  createNewTeam: "Neues Team erstellen",
  teamName: "Teamname",
  enterTeamName: "Teamname eingeben",
  teammates: "Teammitglieder",
  teammate: "Teammitglied",
  enterTeammateNames: "Namen der Teammitglieder eingeben",
  enterAllTeammates: "Alle Teammitgliedernamen eingeben",
  teamSize: "Teamgröße",
  teamWillHave: "Team wird haben",
  youPlus: "Du +",
  editTeam: "Team bearbeiten",
  editTeammatesHint: "Teammitglieder bearbeiten",
  editTeamNote: "Team kann vor Turnierbeginn bearbeitet werden",
  teamUpdated: "Team erfolgreich aktualisiert",
  viewTeams: "Teams anzeigen",
  yourTeam: "Dein Team",
  leader: "Anführer",
  joinThisTeam: "Diesem Team beitreten",
  joinMyTeam: "Meinem Team beitreten",
  joinMyTeamSelect: "Team zum Beitreten auswählen",
  joinWithTeam: "Mit Team beitreten",
  selectYourTeam: "Wähle dein Team",
  joinedTeam: "Team erfolgreich beigetreten",
  leaveTeam: "Team verlassen",
  duplicateTeammate: "Doppelter Teammitgliedname",
  multipleTeamsInvited: "Mehrere Teams können eingeladen werden",
  pendingSlots: "Freie Plätze",
  manageRounds: "Runden verwalten",
  matchSettings: "Spieleinstellungen",
  editSettings: "Einstellungen bearbeiten",
  saveSettings: "Einstellungen speichern",
  saveChanges: "Änderungen speichern",
  settingsSaved: "Einstellungen erfolgreich gespeichert",
  confirmCreate: "Turnier erstellen?",
  confirmStart: "Turnier starten?",
  confirmCancel: "Turnier abbrechen?",
  confirmSwitchToManual: "Zu manueller Steuerung wechseln?",
  switchedToManual: "Zu manueller Steuerung gewechselt",
  roundStarting: "Runde startet",
  lobby: "Lobby",
  inProgress: "Läuft",
  completed: "Abgeschlossen",
  cancelled: "Abgebrochen",
  startsAt: "Beginnt um",
  joining: "Beitreten...",
  creating: "Erstellen...",
  saving: "Speichern...",
  joinTournament: "Turnier beitreten",
  joinedTournament: "Turnier beigetreten",
  leftTournament: "Turnier verlassen",
  tournamentStarted: "Turnier gestartet",
  tournamentCancelled: "Turnier abgebrochen",
  tournamentSummary: "Turnier-Zusammenfassung",
  errorCreating: "Fehler beim Erstellen des Turniers",
  failedToJoin: "Beitritt zum Turnier fehlgeschlagen",
  failedToJoinTeam: "Beitritt zum Team fehlgeschlagen",
  failedToLeave: "Verlassen fehlgeschlagen",
  failedToStart: "Start fehlgeschlagen",
  failedToStartRound: "Rundenstart fehlgeschlagen",
  failedToCancel: "Abbrechen fehlgeschlagen",
  failedToSaveSettings: "Speichern der Einstellungen fehlgeschlagen",
  failedToUpdateTeam: "Team-Update fehlgeschlagen",
  switchFailed: "Wechsel fehlgeschlagen",
  commandFailed: "Befehl fehlgeschlagen",
  reconnectFailed: "Wiederverbindung fehlgeschlagen",
  commandSent: "Befehl gesendet",
  maxPlayers: "Max Spieler",
  leaveEmptyForPublic: "Leer lassen für öffentlich",
  optional: "Optional",
  required: "Erforderlich",
  freeForAdmins: "Kostenlos für Admins",
  minPlayersRequired: "Mindestanzahl Spieler erforderlich",
  playersNotDivisible: "Spielerzahl nicht durch Teamgröße teilbar",
  selectTournamentType: "Turniertyp auswählen",

  weeklyPointDeals: "Wöchentliche Punkt-Angebote",
  subscriptionDescription: "50% Punkte sofort + 50% täglich über 7 Tage",
  activePlan: "Aktiv",
  dayProgress: "Tag",
  pointsReceived: "Punkte erhalten",
  alreadyActive: "Bereits aktiv",
  selectPlan: "Plan auswählen",
  totalPoints: "GESAMTPUNKTE",
  instant: "sofort",
  perDay: "/Tag",
  days: "Tage",
  ptsPerDollar: "Pkt pro $1",
  perWeek: "/Woche",
  processingSubscription: "Ihr Abonnement wird verarbeitet...",
  tierBasic: "Basis",
  tierStandard: "Standard",
  tierPlus: "Plus",
  tierPremium: "Premium",
  tierMax: "Max",
};

export default germanTranslations;
